<template>
  <div class="page-salesforecast pb-15">
    <div class="breadcrumbnew">
      <a>Sales Forecast</a>
      <span>Dashboard</span>
    </div>
    <div v-if="ajaxCallinprogress">
      <half-circle-spinner
        :animation-duration="1000"
        :size="60"
        color="#00448b"
        style="margin: 0 auto;"
      />
    </div>
    <div v-else class="page-content-card px-10">
      <div class>
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-12 mt-10 filter-block">
            <div class="kt-widget17__item" style="height: 110px;">
              <img src="/static/images/benchmark.svg" class="img-forecast" />
              <div class style="padding-left: 20px;padding-top: 6px;">
                <span class="kt-widget17__subtitle">Current Sales Value</span>
                <span
                  class="kt-widget17__desc"
                >{{selectedCompany.currency.symbol}}{{totalCurrentSales}}</span>
                <span class="kt-widget17__subtitle">Current Sales Qty</span>
                <span class="kt-widget17__desc">{{totalCurrentSalesQty}} tons</span>
              </div>
              <span class="kt-widget17__month" @click="createSaleForecast('actual')">
                <i class="icon-plus-circle text-white iconsize-30"></i>
              </span>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12">
            <div id="chart">
              <apexchart type="radialBar" height="250" :options="chartOptions" :series="series"></apexchart>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 mt-10">
            <div class="kt-widget17__item" style="height: 110px;">
              <img src="/static/images/binoculars.svg" class="img-forecast" />
              <div class style="padding-left: 20px;padding-top: 6px;">
                <span class="kt-widget17__subtitle">Sales Forecast Value</span>
                <span class="kt-widget17__desc">{{selectedCompany.currency.symbol}}{{totalForecast}}</span>
                <span class="kt-widget17__subtitle">Sales Forecast Qty</span>
                <span class="kt-widget17__desc">{{totalForecastQty}} tons</span>
              </div>
              <span class="kt-widget17__month" @click="createSaleForecast('forecast')">
                <i class="icon-plus-circle text-white iconsize-30"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-3 mb-0">
          <p class="you-need" v-if="seriesTotal[0] > 0">You need {{seriesTotal[0]}}% more sales to achieve forecast</p>
          <div class="you-need" v-else-if="seriesTotal[0] == 0 && totalForecast > 0">You have achieved your forecast</div>
          <div class="you-need" v-else-if="seriesTotal[0] == 0 && totalForecast == 0">You have no forecast</div>
        </div>
        <div class="row px-20">
          <div class="col-lg-2">
            <div class="d-flex" style="width: 10em;">
              <el-dropdown
                trigger="click"
                :hide-on-click="hide_el_dropdown"
                @visible-change="dropdownTriggered"
                style="border-bottom: 1px solid #ffffff; line-height: 33px;"
              >
                <span class="mr-1" style="font-weight: 600; color: #ffffff; width: 100%; display: block">
                  <span>{{fiscalYear}}</span>
                  <i class="icon-down-dropdown icon-arrow-down-drop"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="fiscal-year-el" style="width: 200px">
                  <el-dropdown-item class="d-flex justify-content-between align-items-center">
                    <i class="icon-chevron-double-left m-0" @click="yearPrev"></i>
                    <span
                      style="font-size: 12px; font-weight: 400"
                    >{{years_to_set[0]}} - {{years_to_set[5]}}</span>
                    <i class="icon-chevron-double-right m-0" @click="yearNext"></i>
                  </el-dropdown-item>
                  <el-dropdown-item
                    class="d-flex flex-column justify-content-center align-items-center"
                  >
                    <span
                      :class="{ 'selectedYear':fiscalYear == `${years_to_set[0]}-${years_to_set[1]}` }"
                      @click="yearClicked(years_to_set[0], years_to_set[1],'fiscal')"
                    >{{years_to_set[0]}} - {{years_to_set[1]}}</span>
                    <span
                      :class="{ 'selectedYear':fiscalYear == `${years_to_set[1]}-${years_to_set[2]}` }"
                      @click="yearClicked(years_to_set[1], years_to_set[2],'fiscal')"
                    >{{years_to_set[1]}} - {{years_to_set[2]}}</span>
                    <span
                      :class="{ 'selectedYear':fiscalYear == `${years_to_set[2]}-${years_to_set[3]}` }"
                      @click="yearClicked(years_to_set[2], years_to_set[3],'fiscal')"
                    >{{years_to_set[2]}} - {{years_to_set[3]}}</span>
                    <span
                      :class="{ 'selectedYear':fiscalYear == `${years_to_set[3]}-${years_to_set[4]}` }"
                      @click="yearClicked(years_to_set[3], years_to_set[4],'fiscal')"
                    >{{years_to_set[3]}} - {{years_to_set[4]}}</span>
                    <span
                      :class="{ 'selectedYear':fiscalYear == `${years_to_set[4]}-${years_to_set[5]}` }"
                      @click="yearClicked(years_to_set[4], years_to_set[5],'fiscal')"
                    >{{years_to_set[4]}} - {{years_to_set[5]}}</span>
                    <a
                      href="javascript:;"
                      class="btn btn-new-primary btn-xsm mt-2 mb-4"
                      @click="getFilteredListData('fiscal')"
                    >Apply</a>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <img src="/static/images/white-calendar.svg" class="mt-2" style="height: 24px;" />
            </div>
          </div>
          <div class="col-lg-10"></div>
        </div>
        <div class="row four-col mx-19">
          <div class="col-lg-3 text-center">
            <span
              class="quarterValue"
            >Q1 Target : {{selectedCompany.currency.symbol}} {{quarter.forecast.one}}</span>
          </div>
          <div class="col-lg-3 text-center">
            <span
              class="quarterValue"
            >Q2 Target : {{selectedCompany.currency.symbol}} {{quarter.forecast.two}}</span>
          </div>
          <div class="col-lg-3 text-center">
            <span
              class="quarterValue"
            >Q3 Target : {{selectedCompany.currency.symbol}} {{quarter.forecast.three}}</span>
          </div>
          <div class="col-lg-3 text-center">
            <span
              class="quarterValue"
            >Q4 Target : {{selectedCompany.currency.symbol}} {{quarter.forecast.four}}</span>
          </div>
        </div>
        <div class="card-sales first-cardsales mt-4">
          <div class="d-flex justify-content-between mx-4">
            <multiselect
              class="diginew-multiselect-lightgrey no-default-icon down-arrow my-4"
              label="name"
              :options="salesCompComparisonOptions"
              :close-on-select="true"
              v-model="salesCompComparison"
              open-direction="bottom"
              @close="getSalesCompChartSelected"
              style="width: 30em !important;"
            ></multiselect>
            <div class="d-flex my-4">
              <multiselect
                class="diginew-multiselect-lightgrey no-default-icon down-arrow mr-4"
                label="name"
                :options="salesCompParameterOptions"
                :close-on-select="true"
                v-model="salesCompParameter"
                open-direction="bottom"
                @close="getSalesCompChart"
                style="width: 10em !important;"
              ></multiselect>
              <div class="switch-field-radio">
                <input
                  type="radio"
                  id="radio-one"
                  name="switch-one"
                  value="monthly"
                  @change="getSalesCompChart"
                  :checked="salesCompInterval === 'monthly'"
                  v-model="salesCompInterval"
                />
                <label for="radio-one">Monthly</label>
                <input
                  type="radio"
                  id="radio-two"
                  name="switch-one"
                  value="quarterly"
                  @change="getSalesCompChart"
                  :checked="salesCompInterval === 'quarterly'"
                  v-model="salesCompInterval"
                />
                <label for="radio-two">Quarterly</label>
                <input
                  type="radio"
                  id="radio-three"
                  name="switch-one"
                  value="yearly"
                  @change="getSalesCompChart"
                  :checked="salesCompInterval === 'yearly'"
                  v-model="salesCompInterval"
                />
                <label for="radio-three">Yearly</label>
              </div>
            </div>
          </div>
          <div
            v-if="noSalesData == true"
            class="d-flex justify-content-center align-items-center"
            style="color:#303031;width:100%;height:500px;"
          >NO DATA</div>
          <div v-else id="chartdiv"></div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-lg-12">
          <div class="headerBlocksWhite">
            <div class="headerBlocksWhite-label">
              <h4 class="text-white font-weight-bold">Products</h4>
            </div>
            <div class="d-flex" style="width: 10em;">
              <el-dropdown
                trigger="click"
                :hide-on-click="hide_el_dropdown"
                @visible-change="dropdownTriggered"
                style="border-bottom: 1px solid #ffffff; line-height: 33px;"
              >
                <span class="mr-1" style="font-weight: 600; color: #ffffff; width: 100%; display: block">
                  <span>{{productsFiscalYear}}</span>
                  <i class="icon-down-dropdown icon-arrow-down-drop"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="fiscal-year-el" style="width: 200px">
                  <el-dropdown-item class="d-flex justify-content-between align-items-center">
                    <i class="icon-chevron-double-left m-0" @click="yearPrev"></i>
                    <span
                      style="font-size: 12px; font-weight: 400"
                    >{{years_to_set[0]}} - {{years_to_set[5]}}</span>
                    <i class="icon-chevron-double-right m-0" @click="yearNext"></i>
                  </el-dropdown-item>
                  <el-dropdown-item
                    class="d-flex flex-column justify-content-center align-items-center"
                  >
                    <span
                      :class="{ 'selectedYear':productsFiscalYear == `${years_to_set[0]}-${years_to_set[1]}` }"
                      @click="yearClicked(years_to_set[0], years_to_set[1],'products')"
                    >{{years_to_set[0]}} - {{years_to_set[1]}}</span>
                    <span
                      :class="{ 'selectedYear':productsFiscalYear == `${years_to_set[1]}-${years_to_set[2]}` }"
                      @click="yearClicked(years_to_set[1], years_to_set[2],'products')"
                    >{{years_to_set[1]}} - {{years_to_set[2]}}</span>
                    <span
                      :class="{ 'selectedYear':productsFiscalYear == `${years_to_set[2]}-${years_to_set[3]}` }"
                      @click="yearClicked(years_to_set[2], years_to_set[3],'products')"
                    >{{years_to_set[2]}} - {{years_to_set[3]}}</span>
                    <span
                      :class="{ 'selectedYear':productsFiscalYear == `${years_to_set[3]}-${years_to_set[4]}` }"
                      @click="yearClicked(years_to_set[3], years_to_set[4],'products')"
                    >{{years_to_set[3]}} - {{years_to_set[4]}}</span>
                    <span
                      :class="{ 'selectedYear':productsFiscalYear == `${years_to_set[4]}-${years_to_set[5]}` }"
                      @click="yearClicked(years_to_set[4], years_to_set[5],'products')"
                    >{{years_to_set[4]}} - {{years_to_set[5]}}</span>
                    <a
                      href="javascript:;"
                      class="btn btn-new-primary btn-xsm mt-2 mb-4"
                      @click="getFilteredListData('products')"
                    >Apply</a>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <img src="/static/images/white-calendar.svg" class="mt-2" style="height: 24px;" />
            </div>
          </div>
        </div>
        <div class="col-lg-4 mt-2">
          <div class="kt-widget17__item">
            <img src="/static/images/product_sales.svg" class="img-forecast" />
            <div class style="padding-left: 20px;padding-top: 6px;">
              <span class="kt-widget17__subtitle">Total Products</span>
              <span class="kt-widget17__desc">{{products.total}}</span>
            </div>
          </div>
        </div>
        <div class="col-lg-4 mt-2">
          <div class="kt-widget17__item">
            <img src="/static/images/product-release.svg" class="img-forecast" />
            <div class style="padding-left: 20px;padding-top: 6px;">
              <span class="kt-widget17__subtitle">New Products</span>
              <span class="kt-widget17__desc">{{products.new}}</span>
            </div>
          </div>
        </div>
        <div class="col-lg-4 mt-2">
          <div class="kt-widget17__item">
            <img src="/static/images/product-release.svg" class="img-forecast" />
            <div class style="padding-left: 20px;padding-top: 6px;">
              <span class="kt-widget17__subtitle">Number of Categories</span>
              <span class="kt-widget17__desc">{{products.categories}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-6 pb-4">
        <div class="col-lg-12">
          <div class="card-sales">
            <div class="headerBlocks">
              <div class="headerBlocks-label">
                <h3>Sales by Categories</h3>
              </div>
              <div class="switch-field-radio">
                <input
                  type="radio"
                  id="radio-four"
                  name="switch-two"
                  value="monthly"
                  @change="getSalesByCategory"
                  :checked="salesCategoryInterval === 'monthly'"
                  v-model="salesCategoryInterval"
                />
                <label for="radio-four">Monthly</label>
                <input
                  type="radio"
                  id="radio-five"
                  name="switch-two"
                  value="quarterly"
                  @change="getSalesByCategory"
                  :checked="salesCategoryInterval === 'quarterly'"
                  v-model="salesCategoryInterval"
                />
                <label for="radio-five">Quarterly</label>
              </div>
            </div>
            <div
              v-if="noSalesByCategory == true"
              class="d-flex justify-content-center align-items-center"
              style="color:#303031;width:100%;height:500px;"
            >NO DATA</div>
            <div v-else id="sales_by_categories"></div>
          </div>
        </div>
      </div>

      <div class="mt-4" style>
        <div class="row mt-6 pb-4">
          <div class="col-lg-12">
            <div class="card-sales">
              <div class="headerBlocks">
                <div class="d-flex align-items-center">
                  <multiselect
                    class="diginew-multiselect-lightgrey text-dark no-default-icon down-arrow"
                    label="name"
                    :options="productTypeOptions"
                    :close-on-select="true"
                    v-model="productType"
                    open-direction="bottom"
                    @close="getAllTopWorstProds"
                    style="width: 20em !important;"
                  ></multiselect>
                  <div style="width: 8em;" class="mx-4">
                    <el-dropdown
                      trigger="click"
                      :hide-on-click="hide_el_dropdown"
                      @visible-change="dropdownTriggered"
                      style="border-bottom: 1px solid #ffffff; line-height: 33px;"
                    >
                      <i class="icon-filter text-dark d-flex justify-content-center align-items-center" style="width: 39px; height: 39px; border: 1px solid #d7dae2; border-radius: 7px;"></i>
                      <el-dropdown-menu slot="dropdown" class="fiscal-year-el indexadjust" style="width: 220px; max-height: 300px; overflow-y: auto; overflow-x: hidden;position:absolute;">
                        <el-dropdown-item class="d-flex justify-content-between align-items-center">
                          <span style="font-weight: 600;">Categories</span>
                        </el-dropdown-item>
                        <el-dropdown-item v-for="(item,index) in salesByCategories[0].value" :key="index" class="d-flex justify-content-between align-items-center">
                          <span class="ml-2" style="font-size: 12px;">{{ item.category }}</span>
                          <input type="checkbox" @change="pushToProdCategories(item.category)">
                        </el-dropdown-item>
                        <el-dropdown-item class="d-flex justify-content-between align-items-center">
                          <span style="font-weight: 600;">Report</span>
                        </el-dropdown-item>
                        <el-dropdown-item class="d-flex justify-content-between align-items-center">
                          <span class="ml-2" style="font-size: 12px;">Value</span>
                          <div class="form-check form-check-inline" style="margin-right: -10px !important;">
                            <label class="form-check-label check-label-dc">
                              <input
                                class="form-check-input"
                                type="radio"
                                v-model="prodComparison"
                                value="sales_compare"
                              />
                              <span class="radio-icon"></span>
                            </label>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item class="d-flex justify-content-between align-items-center">
                          <span class="ml-2" style="font-size: 12px;">Gross Margin</span>
                          <div class="form-check form-check-inline" style="margin-right: -10px !important;">
                            <label class="form-check-label check-label-dc">
                              <input
                                class="form-check-input"
                                type="radio"
                                v-model="prodComparison"
                                value="gross_margin"
                              />
                              <span class="radio-icon"></span>
                            </label>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item class="d-flex justify-content-between align-items-center">
                          <span style="font-weight: 600;">Fiscal Year</span>
                        </el-dropdown-item>
                        <el-dropdown-item class="d-flex justify-content-between align-items-center">
                        <i class="icon-chevron-double-left m-0" @click="yearPrev"></i>
                        <span
                          style="font-size: 12px; font-weight: 400"
                          >{{years_to_set[0]}} - {{years_to_set[5]}}</span>
                          <i class="icon-chevron-double-right m-0" @click="yearNext"></i>
                        </el-dropdown-item>
                        <el-dropdown-item
                          class="d-flex flex-column justify-content-center align-items-center"
                        >
                          <span
                            :class="{ 'selectedYear':prodFiscalYear == `${years_to_set[0]}-${years_to_set[1]}` }"
                            @click="yearClicked(years_to_set[0], years_to_set[1],'all_products')"
                          >{{years_to_set[0]}} - {{years_to_set[1]}}</span>
                          <span
                            :class="{ 'selectedYear':prodFiscalYear == `${years_to_set[1]}-${years_to_set[2]}` }"
                            @click="yearClicked(years_to_set[1], years_to_set[2],'all_products')"
                          >{{years_to_set[1]}} - {{years_to_set[2]}}</span>
                          <span
                            :class="{ 'selectedYear':prodFiscalYear == `${years_to_set[2]}-${years_to_set[3]}` }"
                            @click="yearClicked(years_to_set[2], years_to_set[3],'all_products')"
                          >{{years_to_set[2]}} - {{years_to_set[3]}}</span>
                          <span
                            :class="{ 'selectedYear':prodFiscalYear == `${years_to_set[3]}-${years_to_set[4]}` }"
                            @click="yearClicked(years_to_set[3], years_to_set[4],'all_products')"
                          >{{years_to_set[3]}} - {{years_to_set[4]}}</span>
                          <span
                            :class="{ 'selectedYear':prodFiscalYear == `${years_to_set[4]}-${years_to_set[5]}` }"
                            @click="yearClicked(years_to_set[4], years_to_set[5],'all_products')"
                          >{{years_to_set[4]}} - {{years_to_set[5]}}</span>
                        </el-dropdown-item>
                        <!-- <el-dropdown-item v-for="(item,index) in prodFiscalYears" :key="index" class="d-flex justify-content-between align-items-center">
                          <span class="ml-2" style="font-size: 12px;">{{ item }}</span>
                          <div class="form-check form-check-inline" style="margin-right: -10px !important;">
                            <label class="form-check-label check-label-dc">
                              <input
                                class="form-check-input"
                                type="radio"
                                v-model="prodFiscalYear"
                                :value="item"
                              />
                              <span class="radio-icon"></span>
                            </label>
                          </div>
                        </el-dropdown-item> -->
                        <el-dropdown-item class="d-flex justify-content-center align-items-center">
                          <a href="javascript:;" class="btn btn-new-primary btn-xsm mt-2 mb-4" style="width: 100% !important;" @click="getAllTopWorstProds">Apply</a>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
                <div class="head-toolbar">
                  <div class="kt-widget14__legend">
                    <span class="kt-widget14__bulletcircle kt-bg-primary-light"></span>
                    <span class="kt-widget14__statsblack">Forecast</span>
                  </div>
                  <div class="kt-widget14__legend">
                    <span class="kt-widget14__bulletcircle kt-bg-primary"></span>
                    <span class="kt-widget14__statsblack">Sales</span>
                  </div>
                </div>
              </div>
              <div
                v-if="noProducts"
                class="d-flex justify-content-center align-items-center"
                style="color:#303031;width:100%;height:500px;"
              >NO DATA</div>
              <div v-else id="products_chart"></div>
            </div>
          </div>
        </div>
      </div>
      <div class>
        <div class="row">
          <div class="col-lg-12">
            <div class="headerBlocksWhite">
            <div class="headerBlocksWhite-label">
              <h4 class="text-white font-weight-bold" >Leads</h4>
            </div>
            <div class="d-flex" style="width: 10em;">
              <el-dropdown
                trigger="click"
                :hide-on-click="hide_el_dropdown"
                @visible-change="dropdownTriggered"
                style="border-bottom: 1px solid #ffffff; line-height: 33px;"
              >
                <span class="mr-1" style="font-weight: 600; color: #ffffff; width: 100%; display: block">
                  <span>{{leadsFiscalYear}}</span>
                  <i class="icon-down-dropdown icon-arrow-down-drop"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="fiscal-year-el" style="width: 200px">
                  <el-dropdown-item class="d-flex justify-content-between align-items-center">
                    <i class="icon-chevron-double-left m-0" @click="yearPrev"></i>
                    <span
                      style="font-size: 12px; font-weight: 400"
                    >{{years_to_set[0]}} - {{years_to_set[5]}}</span>
                    <i class="icon-chevron-double-right m-0" @click="yearNext"></i>
                  </el-dropdown-item>
                  <el-dropdown-item
                    class="d-flex flex-column justify-content-center align-items-center"
                  >
                    <span
                      :class="{ 'selectedYear':leadsFiscalYear == `${years_to_set[0]}-${years_to_set[1]}` }"
                      @click="yearClicked(years_to_set[0], years_to_set[1],'leads')"
                    >{{years_to_set[0]}} - {{years_to_set[1]}}</span>
                    <span
                      :class="{ 'selectedYear':leadsFiscalYear == `${years_to_set[1]}-${years_to_set[2]}` }"
                      @click="yearClicked(years_to_set[1], years_to_set[2],'leads')"
                    >{{years_to_set[1]}} - {{years_to_set[2]}}</span>
                    <span
                      :class="{ 'selectedYear':leadsFiscalYear == `${years_to_set[2]}-${years_to_set[3]}` }"
                      @click="yearClicked(years_to_set[2], years_to_set[3],'leads')"
                    >{{years_to_set[2]}} - {{years_to_set[3]}}</span>
                    <span
                      :class="{ 'selectedYear':leadsFiscalYear == `${years_to_set[3]}-${years_to_set[4]}` }"
                      @click="yearClicked(years_to_set[3], years_to_set[4],'leads')"
                    >{{years_to_set[3]}} - {{years_to_set[4]}}</span>
                    <span
                      :class="{ 'selectedYear':leadsFiscalYear == `${years_to_set[4]}-${years_to_set[5]}` }"
                      @click="yearClicked(years_to_set[4], years_to_set[5],'leads')"
                    >{{years_to_set[4]}} - {{years_to_set[5]}}</span>
                    <a
                      href="javascript:;"
                      class="btn btn-new-primary btn-xsm mt-2 mb-4"
                      @click="getFilteredListData('leads')"
                    >Apply</a>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <img src="/static/images/white-calendar.svg" class="mt-2" style="height: 24px;" />
            </div>
          </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-5 mt-5">
            <div class="card-sales card-mb" style="background: #ecf1f9 !important;">
              <p class="leads-table">Leads Table</p>
              <div class="mt-1 ml-3 mr-3 mb-2 leads-table-div">
                <table class="table table-striped" style="height:100%;position: relative">
                  <tbody v-if="!noLeads">
                    <tr v-for="(eachLead,index) in leadstable" :key="index" style="height:10px">
                      <td>{{eachLead.name}}</td>
                      <td>{{eachLead.value}}</td>
                    </tr>
                    <tr
                      class="d-flex justify-content-between"
                      style="background-color: #f29c1f !important;color: #303031;font-weight: 600;border-collapse: separate;position: absolute;bottom: 0;width: 100%"
                    >
                      <td class="font-weight-bold" style="border-radius: 3px 0px 0px 3px;width: 84%">Total Leads</td>
                      <td style="border-radius: 0px 3px 3px 0px;width: 16%">{{totalLeads}}</td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td style="color:#303031;height:255px">
                        <div class="d-flex justify-content-center align-items-center">NO DATA</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- <div v-else class="d-flex justify-content-center align-items-center" style="color:#303031;height:255px">NO DATA</div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-7 mt-5">
            <div
              class="card-mb"
              style="box-shadow: 0 2px 33px 0 rgba(0, 0, 0, 0.07);background-image: linear-gradient(to bottom, #088dff, #001bb1);border-radius:6px;"
            >
              <div class="headerBlocks">
                <div class="headerBlocks-label">
                  <h3 style="color: #fff !important;">Leads Chart</h3>
                </div>
                <div class="head-toolbar"></div>
              </div>
              <div
                v-if="noLeads"
                class="d-flex justify-content-center align-items-center"
                style="color:#fff;width:100%;height:434px;"
              >NO DATA</div>
              <div v-else id="leads_chart" :style="totalLeads === 0 ? 'display:none' : ''"></div>
              <div
                v-if="totalLeads === 0"
                class="d-flex justify-content-center align-items-center"
                style="color:#fff;width:100%;height:434px;"
              >NO LEADS</div>
            </div>
          </div>
        </div>
        <div class="row mt-10">
          <div class="col-lg-12">
            <div class="card-sales">
              <div class="headerBlocks">
                <div class="headerBlocks-label">
                  <h3>Leads Funnel</h3>
                </div>
                <div class="head-toolbar"></div>
                <el-dropdown trigger="click" style="border-bottom: 1px solid #000; line-height: 33px; width: 9em">
                  <span class="mr-1" style="font-weight: 600; color: #000; width: 100%; display: block">
                    <span>{{ leadsFunnelToView }}</span>
                    <i class="icon-down-dropdown icon-arrow-down-drop" style="color: #000 !important"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" class="fiscal-year-el" style="width: 150px">
                    <el-dropdown-item class="d-flex justify-content-between align-items-center" @click.native="leadsFunnelToView = 'Q 1 (Jan - Mar)'">
                      Q 1 (Jan - Mar)
                    </el-dropdown-item>
                    <el-dropdown-item class="d-flex justify-content-between align-items-center" @click.native="leadsFunnelToView = 'Q 2 (Apr - Jun)'">
                      Q 2 (Apr - Jun)
                    </el-dropdown-item>
                    <el-dropdown-item class="d-flex justify-content-between align-items-center" @click.native="leadsFunnelToView = 'Q 3 (Jul - Sep)'">
                      Q 3 (Jul - Sep)
                    </el-dropdown-item>
                    <el-dropdown-item class="d-flex justify-content-between align-items-center" @click.native="leadsFunnelToView = 'Q 4 (Oct - Dec)'">
                      Q 4 (Oct - Dec)
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <p
                v-if="noLeadsFunnel"
                class="d-flex justify-content-center align-items-center"
                style="color:#303031;width:100%;height:500px;"
              >NO DATA</p>
              <p v-else id="leads_funnel" class="mb-8"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="page-middle">
        <div class="mt-5">
          <!-- <div class="row">
            <div class="col-4">
              <p style="color:#fff;font-size:20px;font-weight:600">Customers</p>
            </div>
            <div class="col-4"></div>
            <div class="col-4">
              <p style="color:#fff;font-size:16px;font-weight:600">
                Top 5 Customers
              </p>
            </div>
          </div>-->
          <div class="row">
            <div class="col-lg-12">
              <div class="headerBlocksWhite">
                <div class="headerBlocksWhite-label">
                  <h4 class="text-white font-weight-bold">Customers</h4>
                </div>
                <div class="d-flex" style="width: 10em;">
                  <el-dropdown
                    trigger="click"
                    :hide-on-click="hide_el_dropdown"
                    @visible-change="dropdownTriggered"
                    style="border-bottom: 1px solid #ffffff; line-height: 33px;"
                  >
                    <span class="mr-1" style="font-weight: 600; color: #ffffff; width: 100%; display: block">
                      <span>{{customersFiscalYear}}</span>
                      <i class="icon-down-dropdown icon-arrow-down-drop"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="fiscal-year-el" style="width: 200px">
                      <el-dropdown-item class="d-flex justify-content-between align-items-center">
                        <i class="icon-chevron-double-left m-0" @click="yearPrev"></i>
                        <span
                          style="font-size: 12px; font-weight: 400"
                        >{{years_to_set[0]}} - {{years_to_set[5]}}</span>
                        <i class="icon-chevron-double-right m-0" @click="yearNext"></i>
                      </el-dropdown-item>
                      <el-dropdown-item
                        class="d-flex flex-column justify-content-center align-items-center"
                      >
                        <span
                          :class="{ 'selectedYear':customersFiscalYear == `${years_to_set[0]}-${years_to_set[1]}` }"
                          @click="yearClicked(years_to_set[0], years_to_set[1],'customers')"
                        >{{years_to_set[0]}} - {{years_to_set[1]}}</span>
                        <span
                          :class="{ 'selectedYear':customersFiscalYear == `${years_to_set[1]}-${years_to_set[2]}` }"
                          @click="yearClicked(years_to_set[1], years_to_set[2],'customers')"
                        >{{years_to_set[1]}} - {{years_to_set[2]}}</span>
                        <span
                          :class="{ 'selectedYear':customersFiscalYear == `${years_to_set[2]}-${years_to_set[3]}` }"
                          @click="yearClicked(years_to_set[2], years_to_set[3],'customers')"
                        >{{years_to_set[2]}} - {{years_to_set[3]}}</span>
                        <span
                          :class="{ 'selectedYear':customersFiscalYear == `${years_to_set[3]}-${years_to_set[4]}` }"
                          @click="yearClicked(years_to_set[3], years_to_set[4],'customers')"
                        >{{years_to_set[3]}} - {{years_to_set[4]}}</span>
                        <span
                          :class="{ 'selectedYear':customersFiscalYear == `${years_to_set[4]}-${years_to_set[5]}` }"
                          @click="yearClicked(years_to_set[4], years_to_set[5],'customers')"
                        >{{years_to_set[4]}} - {{years_to_set[5]}}</span>
                        <a
                          href="javascript:;"
                          class="btn btn-new-primary btn-xsm mt-2 mb-4"
                          @click="getFilteredListData('customers')"
                        >Apply</a>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <img src="/static/images/white-calendar.svg" class="mt-2" style="height: 24px;" />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <div class="kt-widget17__item">
                <img src="/static/images/businessman.svg" class="img-forecast" />
                <div class style="padding-left: 20px;padding-top: 6px;">
                  <span class="kt-widget17__subtitle">Total Customers</span>
                  <span class="kt-widget17__desc">{{totalCustomers}}</span>
                </div>
              </div>
              <div class="kt-widget17__item mt-12">
                <img src="/static/images/customers_sales.svg" class="img-forecast" />
                <div class style="padding-left: 20px;padding-top: 6px;">
                  <span class="kt-widget17__subtitle">New Customers</span>
                  <span class="kt-widget17__desc">{{newCustomers}}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-1"></div>
            <div class="col-lg-7">
              <div class="headerBlocksWhite">
                <div class="headerBlocksWhite-label">
                  <h4 class="text-white fw-700">Top 5 Customers</h4>
                </div>
                <div class="head-toolbar">
                  <div class="kt-widget14__legend">
                    <span class="kt-widget14__bullet kt-bg-success"></span>
                    <span class="kt-widget14__stats">Forecast</span>
                  </div>
                  <div class="kt-widget14__legend">
                    <span class="kt-widget14__bullet kt-bg-warning"></span>
                    <span class="kt-widget14__stats">Sales</span>
                  </div>
                </div>
              </div>
              <div
                v-if="noTopFiveCustomers"
                class="d-flex justify-content-center align-items-center"
                style="color:#fff;width:100%;height:250px;"
              >NO DATA</div>
              <div
                v-else
                class="kt-widget4"
                v-for="(topCustomer,index) in topFiveCustomers"
                :key="index"
              >
                <div class="kt-widget4__item">
                  <div class="kt-widget4__img kt-widget4__img--logo" style="overflow: hidden; text-overflow: ellipsis;">{{topCustomer.name}}</div>
                  <div class="kt-widget4__info">
                    <div class="kt-widget4__title">
                      <div class="progress-sales">
                        <div class="d-flex justify-content-center align-items-center">
                          <progress-bar class="pr-1" :val="topCustomer.forecast" bar-color="#29c2e0" bg-color="transparent" style="width: 90%" size="8"></progress-bar>
                          <span class="text-only pl-1 text-right" style="width: 10%">{{topCustomer.forecast}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="kt-widget4__title">
                      <div class="progress-sales">
                        <div class="d-flex justify-content-center align-items-center">
                          <progress-bar class="pr-1" :val="topCustomer.current" bar-color="#fdc72f" bg-color="transparent" style="width: 90%" size="8"></progress-bar>
                          <span class="text-only pl-1 text-right" style="width: 10%">{{topCustomer.current}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div v-else id="top_five_customer"></div> -->
            </div>
          </div>
          <div class="row mt-10 mb-15">
            <div class="col-lg-12">
              <div class="card-sales first-cardsales">
                <div class="headerBlocks">
                  <div class="headerBlocks-label">
                    <h3>Customers</h3>
                  </div>
                  <div class="head-toolbar"></div>
                </div>
                <!-- <div
                  v-if="noMap"
                  class="d-flex justify-content-center align-items-center"
                  style="color:#303031;width:100%;height:350px;"
                >NO DATA</div> -->
                <div id="map_sales_customers"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>

.kt-widget4 .kt-widget4__item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-bottom: 0px solid transparent;
}
.kt-widget4 .kt-widget4__item:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}
.kt-widget4 .kt-widget4__item .kt-widget4__img {
  margin-right: 2.5rem;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  width: 100px;
}
.kt-widget4 .kt-widget4__item .kt-widget4__info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-right: 1.25rem;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}
.kt-widget4 .kt-widget4__item .kt-widget4__title {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding-right: 1.25rem;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -webkit-transition: color 0.3s ease;
  transition: color 0.3s ease;
}
.kt-widget4 .kt-widget4__item .kt-widget4__info .kt-widget4__title {
  font-weight: 600;
  font-size: 14px;
  color: #fff;
}
.kt-widget14__legend {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.kt-widget14__legend .kt-widget14__bullet {
  width: 2.5rem;
  height: 10.5px;
  border-radius: 2px;
}
.kt-widget14__legend .kt-widget14__bulletcircle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
}
.kt-bg-success {
  background-color: #29c2e0 !important;
}
.kt-bg-primary {
  background-color: #005dae !important;
}
.kt-bg-primary-light {
  background-color: #b5e0fb !important;
}
.kt-bg-warning {
  background-color: #fdc72f !important;
}
.kt-widget14__legend .kt-widget14__stats {
  color: #fff;
  font-weight: 600;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-left: 1rem;
  padding-right: 22px;
}
.kt-widget14__legend .kt-widget14__statsblack {
  color: #303031;
  font-weight: 600;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-left: 1rem;
  padding-right: 22px;
}
.headerBlocks {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  position: relative;
  padding: 22px;
  border-bottom: 1px solid transparent;
  min-height: 60px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  align-items: center;
}
.headerBlocks-label {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-line-pack: flex-first;
  align-content: flex-first;
}
.headerBlocks-label h3 {
  margin: 0;
  padding: 0;
  font-size: 20px;
  font-weight: 600;
  color: #303031;
}
.headerBlocks .head-toolbar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-line-pack: end;
  align-content: flex-end;
}

.headerBlocksWhite {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  position: relative;
  padding: 0 2px 0px 2px;
  border-bottom: 1px solid transparent;
  min-height: 60px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  justify-content: space-between;
  align-items: center;
}
.headerBlocksWhite-label {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-line-pack: flex-first;
  align-content: flex-first;
}
.headerBlocksWhite-label h3 {
  margin: 0;
  padding: 0;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
}
.headerBlocksWhite .head-toolbar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-line-pack: end;
  align-content: flex-end;
}
.mx-datepicker.date-white {
  width: 100px !important;
  position: relative !important;
  display: inline-block !important;
  color: #fff !important;
  font: 14px/1.5 "Poppins", sans-serif !important;
}
.mx-datepicker.date-white input {
  border-bottom: 1px solid #fff !important;
}
.mx-datepicker.date-white .mx-input-wrapper input.mx-input {
  height: 32px !important;
  color: #fff !important;
  font-weight: 600 !important;
  font-size: 13px !important;
}
.quarterValue {
  height: 34px;
  border: 0.5px solid #fff;
  border-radius: 5px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 10px;
  display: block;
  width: 100%;
  text-align: center;
}
.col-lg-20 {
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}
@media (min-width: 992px) {
  .quarterValue {
    text-align: center;
  }
  .col-lg-20 {
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 20%;
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
  }
}
text.apexcharts-text.apexcharts-datalabel-label {
  fill: #fff !important;
  font-family: "Poppins", sans-serif !important;
}
.apexcharts-pie-label,
.apexcharts-datalabels,
.apexcharts-datalabel,
.apexcharts-datalabel-label,
.apexcharts-datalabel-value {
  fill: #fff !important;
}
.page-salesforecast {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.page-salesforecast .page-content-card {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  border-radius: 8px;
  background-color: #005dae;
}
/* .page-footer-sales {
  margin-top: 305px;
  background-image: linear-gradient(to bottom, #088dff, #001bb1);
}
.page-salesforecast .page-header {
  background-image: url("/static/images/forecast_bg.svg"),
    linear-gradient(to bottom, #088dff, #001bb1);
}
.page-salesforecast .page-middle {
  background-image: linear-gradient(to bottom, #088dff, #001bb1);
} */
.kt-widget17__item {
  padding: 2rem;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow: hidden;
  border-radius: 7px;
  background-color: #0019d6;
  margin: 0.3rem;
  -webkit-box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.06);
  box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.06);
  cursor: pointer;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  display: flex;
  height: auto !important;
}
.kt-widget17__subtitle {
  display: block;
  font-size: 14px;
  color: #fff;
  font-weight: 600;
}
.kt-widget17__desc {
  font-size: 30px;
  color: #fff;
  font-weight: 700;
}
.kt-widget17__item .kt-widget17__month {
  font-weight: 600;
  text-align: right;
  position: absolute;
  right: 23px;
  top: 7px;
}
.img-forecast {
  padding: 10px;
  border-radius: 5px;
  background-image: linear-gradient(to bottom, #0086f8, #1c78f2 47%, #2d70ee);
  height: 5em;
}
.you-need {
  font-size: 16px;
  text-align: center;
  color: #fff;
  font-weight: 600;
}
.four-col {
  border-radius: 7px;
  background-color: #0019d6;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #fff;
  font-weight: 600;
  margin: 26px 0px 1px 0px;
}
.card-sales {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  background: #ffffff;
  -webkit-box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0.2),
    0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12);
  box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0.2),
    0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  border-radius: 6px;
}
.first-cardsales {
  background-color: #fff;
  top: 30px;
}
#chartdiv,
#leads_funnel,
#products_chart,
#sales_by_categories {
  width: 100%;
  height: 500px;
}
#top_five_customer {
  width: 100%;
  height: 300px;
}
#leads_chart {
  width: 100%;
  height: 434px;
}
#pie_middle_top {
  width: 100%;
  height: 200px;
}
#map_sales_customers {
  width: 100%;
  height: 350px;
}
.percent-text {
  font-weight: 600;
  color: #fff;
  font-size: 20px !important;
}
.leads-table {
  background-color: #005dae;
  color: #fff;
  margin: 10px 10px 0px 10px;
  border-radius: 3px;
  padding: 9px 9px 9px 12px;
  font-size: 14px;
  font-weight: 600;
}

.leads-table-div {
  height: 447px;
  max-height: 497px;
  overflow-y: auto;
}

.leads-table-div table td {
  padding: 8px 8px 8px 12px !important;
  color: #303031;
}

.leads-table-div .table > tbody > tr:nth-of-type(odd) {
  background-color: #dee8f2;
  border-collapse: separate;
  border-radius: 1px;
}
.progress-sales {
  border-radius: 0;
  box-shadow: none;
  margin-bottom: 10px;
  overflow: visible;
  background-color: transparent;
}
.progress-sales .progress-bar-sales {
  background-color: #9debff;
}
.progress-bar-sales .text-only {
  color: #fff;
  font-size: 11px;
  font-weight: bold;
  position: relative;
  right: -102%;
  top: -8px;
}
.progress-sales-second {
  border-radius: 0;
  box-shadow: none;
  margin-bottom: 10px;
  overflow: visible;
  background-color: transparent;
}
.progress-sales-second .progress-bar-sales-second {
  background-color: #fdcc72;
}
.progress-bar-sales-second .text-only {
  color: #fff;
  font-size: 11px;
  font-weight: bold;
  position: relative;
  right: -102%;
  top: -8px;
}

.rect-auto,
.c100.p51 .slice,
.c100.p52 .slice,
.c100.p53 .slice,
.c100.p54 .slice,
.c100.p55 .slice,
.c100.p56 .slice,
.c100.p57 .slice,
.c100.p58 .slice,
.c100.p59 .slice,
.c100.p60 .slice,
.c100.p61 .slice,
.c100.p62 .slice,
.c100.p63 .slice,
.c100.p64 .slice,
.c100.p65 .slice,
.c100.p66 .slice,
.c100.p67 .slice,
.c100.p68 .slice,
.c100.p69 .slice,
.c100.p70 .slice,
.c100.p71 .slice,
.c100.p72 .slice,
.c100.p73 .slice,
.c100.p74 .slice,
.c100.p75 .slice,
.c100.p76 .slice,
.c100.p77 .slice,
.c100.p78 .slice,
.c100.p79 .slice,
.c100.p80 .slice,
.c100.p81 .slice,
.c100.p82 .slice,
.c100.p83 .slice,
.c100.p84 .slice,
.c100.p85 .slice,
.c100.p86 .slice,
.c100.p87 .slice,
.c100.p88 .slice,
.c100.p89 .slice,
.c100.p90 .slice,
.c100.p91 .slice,
.c100.p92 .slice,
.c100.p93 .slice,
.c100.p94 .slice,
.c100.p95 .slice,
.c100.p96 .slice,
.c100.p97 .slice,
.c100.p98 .slice,
.c100.p99 .slice,
.c100.p100 .slice {
  clip: rect(auto, auto, auto, auto);
}
.pie,
.c100 .bar,
.c100.p51 .fill,
.c100.p52 .fill,
.c100.p53 .fill,
.c100.p54 .fill,
.c100.p55 .fill,
.c100.p56 .fill,
.c100.p57 .fill,
.c100.p58 .fill,
.c100.p59 .fill,
.c100.p60 .fill,
.c100.p61 .fill,
.c100.p62 .fill,
.c100.p63 .fill,
.c100.p64 .fill,
.c100.p65 .fill,
.c100.p66 .fill,
.c100.p67 .fill,
.c100.p68 .fill,
.c100.p69 .fill,
.c100.p70 .fill,
.c100.p71 .fill,
.c100.p72 .fill,
.c100.p73 .fill,
.c100.p74 .fill,
.c100.p75 .fill,
.c100.p76 .fill,
.c100.p77 .fill,
.c100.p78 .fill,
.c100.p79 .fill,
.c100.p80 .fill,
.c100.p81 .fill,
.c100.p82 .fill,
.c100.p83 .fill,
.c100.p84 .fill,
.c100.p85 .fill,
.c100.p86 .fill,
.c100.p87 .fill,
.c100.p88 .fill,
.c100.p89 .fill,
.c100.p90 .fill,
.c100.p91 .fill,
.c100.p92 .fill,
.c100.p93 .fill,
.c100.p94 .fill,
.c100.p95 .fill,
.c100.p96 .fill,
.c100.p97 .fill,
.c100.p98 .fill,
.c100.p99 .fill,
.c100.p100 .fill {
  position: absolute;
  border: 0.08em solid #307bbb;
  width: 0.84em;
  height: 0.84em;
  clip: rect(0em, 0.5em, 1em, 0em);
  border-radius: 50%;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
}
.pie-fill,
.c100.p51 .bar:after,
.c100.p51 .fill,
.c100.p52 .bar:after,
.c100.p52 .fill,
.c100.p53 .bar:after,
.c100.p53 .fill,
.c100.p54 .bar:after,
.c100.p54 .fill,
.c100.p55 .bar:after,
.c100.p55 .fill,
.c100.p56 .bar:after,
.c100.p56 .fill,
.c100.p57 .bar:after,
.c100.p57 .fill,
.c100.p58 .bar:after,
.c100.p58 .fill,
.c100.p59 .bar:after,
.c100.p59 .fill,
.c100.p60 .bar:after,
.c100.p60 .fill,
.c100.p61 .bar:after,
.c100.p61 .fill,
.c100.p62 .bar:after,
.c100.p62 .fill,
.c100.p63 .bar:after,
.c100.p63 .fill,
.c100.p64 .bar:after,
.c100.p64 .fill,
.c100.p65 .bar:after,
.c100.p65 .fill,
.c100.p66 .bar:after,
.c100.p66 .fill,
.c100.p67 .bar:after,
.c100.p67 .fill,
.c100.p68 .bar:after,
.c100.p68 .fill,
.c100.p69 .bar:after,
.c100.p69 .fill,
.c100.p70 .bar:after,
.c100.p70 .fill,
.c100.p71 .bar:after,
.c100.p71 .fill,
.c100.p72 .bar:after,
.c100.p72 .fill,
.c100.p73 .bar:after,
.c100.p73 .fill,
.c100.p74 .bar:after,
.c100.p74 .fill,
.c100.p75 .bar:after,
.c100.p75 .fill,
.c100.p76 .bar:after,
.c100.p76 .fill,
.c100.p77 .bar:after,
.c100.p77 .fill,
.c100.p78 .bar:after,
.c100.p78 .fill,
.c100.p79 .bar:after,
.c100.p79 .fill,
.c100.p80 .bar:after,
.c100.p80 .fill,
.c100.p81 .bar:after,
.c100.p81 .fill,
.c100.p82 .bar:after,
.c100.p82 .fill,
.c100.p83 .bar:after,
.c100.p83 .fill,
.c100.p84 .bar:after,
.c100.p84 .fill,
.c100.p85 .bar:after,
.c100.p85 .fill,
.c100.p86 .bar:after,
.c100.p86 .fill,
.c100.p87 .bar:after,
.c100.p87 .fill,
.c100.p88 .bar:after,
.c100.p88 .fill,
.c100.p89 .bar:after,
.c100.p89 .fill,
.c100.p90 .bar:after,
.c100.p90 .fill,
.c100.p91 .bar:after,
.c100.p91 .fill,
.c100.p92 .bar:after,
.c100.p92 .fill,
.c100.p93 .bar:after,
.c100.p93 .fill,
.c100.p94 .bar:after,
.c100.p94 .fill,
.c100.p95 .bar:after,
.c100.p95 .fill,
.c100.p96 .bar:after,
.c100.p96 .fill,
.c100.p97 .bar:after,
.c100.p97 .fill,
.c100.p98 .bar:after,
.c100.p98 .fill,
.c100.p99 .bar:after,
.c100.p99 .fill,
.c100.p100 .bar:after,
.c100.p100 .fill {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
.c100 {
  position: relative;
  font-size: 120px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  margin: 0 0.1em 0.1em 0;
  background-color: #cccccc;
  text-align: center;
  margin: 0 auto;
  margin-top: 30px;
}
.c100 *,
.c100 *:before,
.c100 *:after {
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
}
.c100.center {
  float: none;
  margin: 0 auto;
}
.c100.big {
  font-size: 240px;
}
.c100.small {
  font-size: 80px;
}
.c100 > span {
  position: absolute;
  width: 100%;
  z-index: 1;
  left: 0;
  top: 0;
  width: 5em;
  line-height: 5em;
  font-size: 0.2em;
  color: #cccccc;
  display: block;
  text-align: center;
  white-space: nowrap;
  -webkit-transition-property: all;
  -moz-transition-property: all;
  -o-transition-property: all;
  transition-property: all;
  -webkit-transition-duration: 0.2s;
  -moz-transition-duration: 0.2s;
  -o-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -webkit-transition-timing-function: ease-out;
  -moz-transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
.c100:after {
  position: absolute;
  top: 0.08em;
  left: 0.08em;
  display: block;
  content: " ";
  border-radius: 50%;
  background-color: #f5f5f5;
  width: 0.84em;
  height: 0.84em;
  -webkit-transition-property: all;
  -moz-transition-property: all;
  -o-transition-property: all;
  transition-property: all;
  -webkit-transition-duration: 0.2s;
  -moz-transition-duration: 0.2s;
  -o-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -webkit-transition-timing-function: ease-in;
  -moz-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}
.c100 .slice {
  position: absolute;
  width: 1em;
  height: 1em;
  clip: rect(0em, 1em, 1em, 0.5em);
}
.c100.p1 .bar {
  -webkit-transform: rotate(3.6deg);
  -moz-transform: rotate(3.6deg);
  -ms-transform: rotate(3.6deg);
  -o-transform: rotate(3.6deg);
  transform: rotate(3.6deg);
}
.c100.p2 .bar {
  -webkit-transform: rotate(7.2deg);
  -moz-transform: rotate(7.2deg);
  -ms-transform: rotate(7.2deg);
  -o-transform: rotate(7.2deg);
  transform: rotate(7.2deg);
}
.c100.p3 .bar {
  -webkit-transform: rotate(10.8deg);
  -moz-transform: rotate(10.8deg);
  -ms-transform: rotate(10.8deg);
  -o-transform: rotate(10.8deg);
  transform: rotate(10.8deg);
}
.c100.p4 .bar {
  -webkit-transform: rotate(14.4deg);
  -moz-transform: rotate(14.4deg);
  -ms-transform: rotate(14.4deg);
  -o-transform: rotate(14.4deg);
  transform: rotate(14.4deg);
}
.c100.p5 .bar {
  -webkit-transform: rotate(18deg);
  -moz-transform: rotate(18deg);
  -ms-transform: rotate(18deg);
  -o-transform: rotate(18deg);
  transform: rotate(18deg);
}
.c100.p6 .bar {
  -webkit-transform: rotate(21.6deg);
  -moz-transform: rotate(21.6deg);
  -ms-transform: rotate(21.6deg);
  -o-transform: rotate(21.6deg);
  transform: rotate(21.6deg);
}
.c100.p7 .bar {
  -webkit-transform: rotate(25.2deg);
  -moz-transform: rotate(25.2deg);
  -ms-transform: rotate(25.2deg);
  -o-transform: rotate(25.2deg);
  transform: rotate(25.2deg);
}
.c100.p8 .bar {
  -webkit-transform: rotate(28.8deg);
  -moz-transform: rotate(28.8deg);
  -ms-transform: rotate(28.8deg);
  -o-transform: rotate(28.8deg);
  transform: rotate(28.8deg);
}
.c100.p9 .bar {
  -webkit-transform: rotate(32.4deg);
  -moz-transform: rotate(32.4deg);
  -ms-transform: rotate(32.4deg);
  -o-transform: rotate(32.4deg);
  transform: rotate(32.4deg);
}
.c100.p10 .bar {
  -webkit-transform: rotate(36deg);
  -moz-transform: rotate(36deg);
  -ms-transform: rotate(36deg);
  -o-transform: rotate(36deg);
  transform: rotate(36deg);
}
.c100.p11 .bar {
  -webkit-transform: rotate(39.6deg);
  -moz-transform: rotate(39.6deg);
  -ms-transform: rotate(39.6deg);
  -o-transform: rotate(39.6deg);
  transform: rotate(39.6deg);
}
.c100.p12 .bar {
  -webkit-transform: rotate(43.2deg);
  -moz-transform: rotate(43.2deg);
  -ms-transform: rotate(43.2deg);
  -o-transform: rotate(43.2deg);
  transform: rotate(43.2deg);
}
.c100.p13 .bar {
  -webkit-transform: rotate(46.800000000000004deg);
  -moz-transform: rotate(46.800000000000004deg);
  -ms-transform: rotate(46.800000000000004deg);
  -o-transform: rotate(46.800000000000004deg);
  transform: rotate(46.800000000000004deg);
}
.c100.p14 .bar {
  -webkit-transform: rotate(50.4deg);
  -moz-transform: rotate(50.4deg);
  -ms-transform: rotate(50.4deg);
  -o-transform: rotate(50.4deg);
  transform: rotate(50.4deg);
}
.c100.p15 .bar {
  -webkit-transform: rotate(54deg);
  -moz-transform: rotate(54deg);
  -ms-transform: rotate(54deg);
  -o-transform: rotate(54deg);
  transform: rotate(54deg);
}
.c100.p16 .bar {
  -webkit-transform: rotate(57.6deg);
  -moz-transform: rotate(57.6deg);
  -ms-transform: rotate(57.6deg);
  -o-transform: rotate(57.6deg);
  transform: rotate(57.6deg);
}
.c100.p17 .bar {
  -webkit-transform: rotate(61.2deg);
  -moz-transform: rotate(61.2deg);
  -ms-transform: rotate(61.2deg);
  -o-transform: rotate(61.2deg);
  transform: rotate(61.2deg);
}
.c100.p18 .bar {
  -webkit-transform: rotate(64.8deg);
  -moz-transform: rotate(64.8deg);
  -ms-transform: rotate(64.8deg);
  -o-transform: rotate(64.8deg);
  transform: rotate(64.8deg);
}
.c100.p19 .bar {
  -webkit-transform: rotate(68.4deg);
  -moz-transform: rotate(68.4deg);
  -ms-transform: rotate(68.4deg);
  -o-transform: rotate(68.4deg);
  transform: rotate(68.4deg);
}
.c100.p20 .bar {
  -webkit-transform: rotate(72deg);
  -moz-transform: rotate(72deg);
  -ms-transform: rotate(72deg);
  -o-transform: rotate(72deg);
  transform: rotate(72deg);
}
.c100.p21 .bar {
  -webkit-transform: rotate(75.60000000000001deg);
  -moz-transform: rotate(75.60000000000001deg);
  -ms-transform: rotate(75.60000000000001deg);
  -o-transform: rotate(75.60000000000001deg);
  transform: rotate(75.60000000000001deg);
}
.c100.p22 .bar {
  -webkit-transform: rotate(79.2deg);
  -moz-transform: rotate(79.2deg);
  -ms-transform: rotate(79.2deg);
  -o-transform: rotate(79.2deg);
  transform: rotate(79.2deg);
}
.c100.p23 .bar {
  -webkit-transform: rotate(82.8deg);
  -moz-transform: rotate(82.8deg);
  -ms-transform: rotate(82.8deg);
  -o-transform: rotate(82.8deg);
  transform: rotate(82.8deg);
}
.c100.p24 .bar {
  -webkit-transform: rotate(86.4deg);
  -moz-transform: rotate(86.4deg);
  -ms-transform: rotate(86.4deg);
  -o-transform: rotate(86.4deg);
  transform: rotate(86.4deg);
}
.c100.p25 .bar {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}
.c100.p26 .bar {
  -webkit-transform: rotate(93.60000000000001deg);
  -moz-transform: rotate(93.60000000000001deg);
  -ms-transform: rotate(93.60000000000001deg);
  -o-transform: rotate(93.60000000000001deg);
  transform: rotate(93.60000000000001deg);
}
.c100.p27 .bar {
  -webkit-transform: rotate(97.2deg);
  -moz-transform: rotate(97.2deg);
  -ms-transform: rotate(97.2deg);
  -o-transform: rotate(97.2deg);
  transform: rotate(97.2deg);
}
.c100.p28 .bar {
  -webkit-transform: rotate(100.8deg);
  -moz-transform: rotate(100.8deg);
  -ms-transform: rotate(100.8deg);
  -o-transform: rotate(100.8deg);
  transform: rotate(100.8deg);
}
.c100.p29 .bar {
  -webkit-transform: rotate(104.4deg);
  -moz-transform: rotate(104.4deg);
  -ms-transform: rotate(104.4deg);
  -o-transform: rotate(104.4deg);
  transform: rotate(104.4deg);
}
.c100.p30 .bar {
  -webkit-transform: rotate(108deg);
  -moz-transform: rotate(108deg);
  -ms-transform: rotate(108deg);
  -o-transform: rotate(108deg);
  transform: rotate(108deg);
}
.c100.p31 .bar {
  -webkit-transform: rotate(111.60000000000001deg);
  -moz-transform: rotate(111.60000000000001deg);
  -ms-transform: rotate(111.60000000000001deg);
  -o-transform: rotate(111.60000000000001deg);
  transform: rotate(111.60000000000001deg);
}
.c100.p32 .bar {
  -webkit-transform: rotate(115.2deg);
  -moz-transform: rotate(115.2deg);
  -ms-transform: rotate(115.2deg);
  -o-transform: rotate(115.2deg);
  transform: rotate(115.2deg);
}
.c100.p33 .bar {
  -webkit-transform: rotate(118.8deg);
  -moz-transform: rotate(118.8deg);
  -ms-transform: rotate(118.8deg);
  -o-transform: rotate(118.8deg);
  transform: rotate(118.8deg);
}
.c100.p34 .bar {
  -webkit-transform: rotate(122.4deg);
  -moz-transform: rotate(122.4deg);
  -ms-transform: rotate(122.4deg);
  -o-transform: rotate(122.4deg);
  transform: rotate(122.4deg);
}
.c100.p35 .bar {
  -webkit-transform: rotate(126deg);
  -moz-transform: rotate(126deg);
  -ms-transform: rotate(126deg);
  -o-transform: rotate(126deg);
  transform: rotate(126deg);
}
.c100.p36 .bar {
  -webkit-transform: rotate(129.6deg);
  -moz-transform: rotate(129.6deg);
  -ms-transform: rotate(129.6deg);
  -o-transform: rotate(129.6deg);
  transform: rotate(129.6deg);
}
.c100.p37 .bar {
  -webkit-transform: rotate(133.20000000000002deg);
  -moz-transform: rotate(133.20000000000002deg);
  -ms-transform: rotate(133.20000000000002deg);
  -o-transform: rotate(133.20000000000002deg);
  transform: rotate(133.20000000000002deg);
}
.c100.p38 .bar {
  -webkit-transform: rotate(136.8deg);
  -moz-transform: rotate(136.8deg);
  -ms-transform: rotate(136.8deg);
  -o-transform: rotate(136.8deg);
  transform: rotate(136.8deg);
}
.c100.p39 .bar {
  -webkit-transform: rotate(140.4deg);
  -moz-transform: rotate(140.4deg);
  -ms-transform: rotate(140.4deg);
  -o-transform: rotate(140.4deg);
  transform: rotate(140.4deg);
}
.c100.p40 .bar {
  -webkit-transform: rotate(144deg);
  -moz-transform: rotate(144deg);
  -ms-transform: rotate(144deg);
  -o-transform: rotate(144deg);
  transform: rotate(144deg);
}
.c100.p41 .bar {
  -webkit-transform: rotate(147.6deg);
  -moz-transform: rotate(147.6deg);
  -ms-transform: rotate(147.6deg);
  -o-transform: rotate(147.6deg);
  transform: rotate(147.6deg);
}
.c100.p42 .bar {
  -webkit-transform: rotate(151.20000000000002deg);
  -moz-transform: rotate(151.20000000000002deg);
  -ms-transform: rotate(151.20000000000002deg);
  -o-transform: rotate(151.20000000000002deg);
  transform: rotate(151.20000000000002deg);
}
.c100.p43 .bar {
  -webkit-transform: rotate(154.8deg);
  -moz-transform: rotate(154.8deg);
  -ms-transform: rotate(154.8deg);
  -o-transform: rotate(154.8deg);
  transform: rotate(154.8deg);
}
.c100.p44 .bar {
  -webkit-transform: rotate(158.4deg);
  -moz-transform: rotate(158.4deg);
  -ms-transform: rotate(158.4deg);
  -o-transform: rotate(158.4deg);
  transform: rotate(158.4deg);
}
.c100.p45 .bar {
  -webkit-transform: rotate(162deg);
  -moz-transform: rotate(162deg);
  -ms-transform: rotate(162deg);
  -o-transform: rotate(162deg);
  transform: rotate(162deg);
}
.c100.p46 .bar {
  -webkit-transform: rotate(165.6deg);
  -moz-transform: rotate(165.6deg);
  -ms-transform: rotate(165.6deg);
  -o-transform: rotate(165.6deg);
  transform: rotate(165.6deg);
}
.c100.p47 .bar {
  -webkit-transform: rotate(169.20000000000002deg);
  -moz-transform: rotate(169.20000000000002deg);
  -ms-transform: rotate(169.20000000000002deg);
  -o-transform: rotate(169.20000000000002deg);
  transform: rotate(169.20000000000002deg);
}
.c100.p48 .bar {
  -webkit-transform: rotate(172.8deg);
  -moz-transform: rotate(172.8deg);
  -ms-transform: rotate(172.8deg);
  -o-transform: rotate(172.8deg);
  transform: rotate(172.8deg);
}
.c100.p49 .bar {
  -webkit-transform: rotate(176.4deg);
  -moz-transform: rotate(176.4deg);
  -ms-transform: rotate(176.4deg);
  -o-transform: rotate(176.4deg);
  transform: rotate(176.4deg);
}
.c100.p50 .bar {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
.c100.p51 .bar {
  -webkit-transform: rotate(183.6deg);
  -moz-transform: rotate(183.6deg);
  -ms-transform: rotate(183.6deg);
  -o-transform: rotate(183.6deg);
  transform: rotate(183.6deg);
}
.c100.p52 .bar {
  -webkit-transform: rotate(187.20000000000002deg);
  -moz-transform: rotate(187.20000000000002deg);
  -ms-transform: rotate(187.20000000000002deg);
  -o-transform: rotate(187.20000000000002deg);
  transform: rotate(187.20000000000002deg);
}
.c100.p53 .bar {
  -webkit-transform: rotate(190.8deg);
  -moz-transform: rotate(190.8deg);
  -ms-transform: rotate(190.8deg);
  -o-transform: rotate(190.8deg);
  transform: rotate(190.8deg);
}
.c100.p54 .bar {
  -webkit-transform: rotate(194.4deg);
  -moz-transform: rotate(194.4deg);
  -ms-transform: rotate(194.4deg);
  -o-transform: rotate(194.4deg);
  transform: rotate(194.4deg);
}
.c100.p55 .bar {
  -webkit-transform: rotate(198deg);
  -moz-transform: rotate(198deg);
  -ms-transform: rotate(198deg);
  -o-transform: rotate(198deg);
  transform: rotate(198deg);
}
.c100.p56 .bar {
  -webkit-transform: rotate(201.6deg);
  -moz-transform: rotate(201.6deg);
  -ms-transform: rotate(201.6deg);
  -o-transform: rotate(201.6deg);
  transform: rotate(201.6deg);
}
.c100.p57 .bar {
  -webkit-transform: rotate(205.20000000000002deg);
  -moz-transform: rotate(205.20000000000002deg);
  -ms-transform: rotate(205.20000000000002deg);
  -o-transform: rotate(205.20000000000002deg);
  transform: rotate(205.20000000000002deg);
}
.c100.p58 .bar {
  -webkit-transform: rotate(208.8deg);
  -moz-transform: rotate(208.8deg);
  -ms-transform: rotate(208.8deg);
  -o-transform: rotate(208.8deg);
  transform: rotate(208.8deg);
}
.c100.p59 .bar {
  -webkit-transform: rotate(212.4deg);
  -moz-transform: rotate(212.4deg);
  -ms-transform: rotate(212.4deg);
  -o-transform: rotate(212.4deg);
  transform: rotate(212.4deg);
}
.c100.p60 .bar {
  -webkit-transform: rotate(216deg);
  -moz-transform: rotate(216deg);
  -ms-transform: rotate(216deg);
  -o-transform: rotate(216deg);
  transform: rotate(216deg);
}
.c100.p61 .bar {
  -webkit-transform: rotate(219.6deg);
  -moz-transform: rotate(219.6deg);
  -ms-transform: rotate(219.6deg);
  -o-transform: rotate(219.6deg);
  transform: rotate(219.6deg);
}
.c100.p62 .bar {
  -webkit-transform: rotate(223.20000000000002deg);
  -moz-transform: rotate(223.20000000000002deg);
  -ms-transform: rotate(223.20000000000002deg);
  -o-transform: rotate(223.20000000000002deg);
  transform: rotate(223.20000000000002deg);
}
.c100.p63 .bar {
  -webkit-transform: rotate(226.8deg);
  -moz-transform: rotate(226.8deg);
  -ms-transform: rotate(226.8deg);
  -o-transform: rotate(226.8deg);
  transform: rotate(226.8deg);
}
.c100.p64 .bar {
  -webkit-transform: rotate(230.4deg);
  -moz-transform: rotate(230.4deg);
  -ms-transform: rotate(230.4deg);
  -o-transform: rotate(230.4deg);
  transform: rotate(230.4deg);
}
.c100.p65 .bar {
  -webkit-transform: rotate(234deg);
  -moz-transform: rotate(234deg);
  -ms-transform: rotate(234deg);
  -o-transform: rotate(234deg);
  transform: rotate(234deg);
}
.c100.p66 .bar {
  -webkit-transform: rotate(237.6deg);
  -moz-transform: rotate(237.6deg);
  -ms-transform: rotate(237.6deg);
  -o-transform: rotate(237.6deg);
  transform: rotate(237.6deg);
}
.c100.p67 .bar {
  -webkit-transform: rotate(241.20000000000002deg);
  -moz-transform: rotate(241.20000000000002deg);
  -ms-transform: rotate(241.20000000000002deg);
  -o-transform: rotate(241.20000000000002deg);
  transform: rotate(241.20000000000002deg);
}
.c100.p68 .bar {
  -webkit-transform: rotate(244.8deg);
  -moz-transform: rotate(244.8deg);
  -ms-transform: rotate(244.8deg);
  -o-transform: rotate(244.8deg);
  transform: rotate(244.8deg);
}
.c100.p69 .bar {
  -webkit-transform: rotate(248.4deg);
  -moz-transform: rotate(248.4deg);
  -ms-transform: rotate(248.4deg);
  -o-transform: rotate(248.4deg);
  transform: rotate(248.4deg);
}
.c100.p70 .bar {
  -webkit-transform: rotate(252deg);
  -moz-transform: rotate(252deg);
  -ms-transform: rotate(252deg);
  -o-transform: rotate(252deg);
  transform: rotate(252deg);
}
.c100.p71 .bar {
  -webkit-transform: rotate(255.6deg);
  -moz-transform: rotate(255.6deg);
  -ms-transform: rotate(255.6deg);
  -o-transform: rotate(255.6deg);
  transform: rotate(255.6deg);
}
.c100.p72 .bar {
  -webkit-transform: rotate(259.2deg);
  -moz-transform: rotate(259.2deg);
  -ms-transform: rotate(259.2deg);
  -o-transform: rotate(259.2deg);
  transform: rotate(259.2deg);
}
.c100.p73 .bar {
  -webkit-transform: rotate(262.8deg);
  -moz-transform: rotate(262.8deg);
  -ms-transform: rotate(262.8deg);
  -o-transform: rotate(262.8deg);
  transform: rotate(262.8deg);
}
.c100.p74 .bar {
  -webkit-transform: rotate(266.40000000000003deg);
  -moz-transform: rotate(266.40000000000003deg);
  -ms-transform: rotate(266.40000000000003deg);
  -o-transform: rotate(266.40000000000003deg);
  transform: rotate(266.40000000000003deg);
}
.c100.p75 .bar {
  -webkit-transform: rotate(270deg);
  -moz-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  -o-transform: rotate(270deg);
  transform: rotate(270deg);
}
.c100.p76 .bar {
  -webkit-transform: rotate(273.6deg);
  -moz-transform: rotate(273.6deg);
  -ms-transform: rotate(273.6deg);
  -o-transform: rotate(273.6deg);
  transform: rotate(273.6deg);
}
.c100.p77 .bar {
  -webkit-transform: rotate(277.2deg);
  -moz-transform: rotate(277.2deg);
  -ms-transform: rotate(277.2deg);
  -o-transform: rotate(277.2deg);
  transform: rotate(277.2deg);
}
.c100.p78 .bar {
  -webkit-transform: rotate(280.8deg);
  -moz-transform: rotate(280.8deg);
  -ms-transform: rotate(280.8deg);
  -o-transform: rotate(280.8deg);
  transform: rotate(280.8deg);
}
.c100.p79 .bar {
  -webkit-transform: rotate(284.40000000000003deg);
  -moz-transform: rotate(284.40000000000003deg);
  -ms-transform: rotate(284.40000000000003deg);
  -o-transform: rotate(284.40000000000003deg);
  transform: rotate(284.40000000000003deg);
}
.c100.p80 .bar {
  -webkit-transform: rotate(288deg);
  -moz-transform: rotate(288deg);
  -ms-transform: rotate(288deg);
  -o-transform: rotate(288deg);
  transform: rotate(288deg);
}
.c100.p81 .bar {
  -webkit-transform: rotate(291.6deg);
  -moz-transform: rotate(291.6deg);
  -ms-transform: rotate(291.6deg);
  -o-transform: rotate(291.6deg);
  transform: rotate(291.6deg);
}
.c100.p82 .bar {
  -webkit-transform: rotate(295.2deg);
  -moz-transform: rotate(295.2deg);
  -ms-transform: rotate(295.2deg);
  -o-transform: rotate(295.2deg);
  transform: rotate(295.2deg);
}
.c100.p83 .bar {
  -webkit-transform: rotate(298.8deg);
  -moz-transform: rotate(298.8deg);
  -ms-transform: rotate(298.8deg);
  -o-transform: rotate(298.8deg);
  transform: rotate(298.8deg);
}
.c100.p84 .bar {
  -webkit-transform: rotate(302.40000000000003deg);
  -moz-transform: rotate(302.40000000000003deg);
  -ms-transform: rotate(302.40000000000003deg);
  -o-transform: rotate(302.40000000000003deg);
  transform: rotate(302.40000000000003deg);
}
.c100.p85 .bar {
  -webkit-transform: rotate(306deg);
  -moz-transform: rotate(306deg);
  -ms-transform: rotate(306deg);
  -o-transform: rotate(306deg);
  transform: rotate(306deg);
}
.c100.p86 .bar {
  -webkit-transform: rotate(309.6deg);
  -moz-transform: rotate(309.6deg);
  -ms-transform: rotate(309.6deg);
  -o-transform: rotate(309.6deg);
  transform: rotate(309.6deg);
}
.c100.p87 .bar {
  -webkit-transform: rotate(313.2deg);
  -moz-transform: rotate(313.2deg);
  -ms-transform: rotate(313.2deg);
  -o-transform: rotate(313.2deg);
  transform: rotate(313.2deg);
}
.c100.p88 .bar {
  -webkit-transform: rotate(316.8deg);
  -moz-transform: rotate(316.8deg);
  -ms-transform: rotate(316.8deg);
  -o-transform: rotate(316.8deg);
  transform: rotate(316.8deg);
}
.c100.p89 .bar {
  -webkit-transform: rotate(320.40000000000003deg);
  -moz-transform: rotate(320.40000000000003deg);
  -ms-transform: rotate(320.40000000000003deg);
  -o-transform: rotate(320.40000000000003deg);
  transform: rotate(320.40000000000003deg);
}
.c100.p90 .bar {
  -webkit-transform: rotate(324deg);
  -moz-transform: rotate(324deg);
  -ms-transform: rotate(324deg);
  -o-transform: rotate(324deg);
  transform: rotate(324deg);
}
.c100.p91 .bar {
  -webkit-transform: rotate(327.6deg);
  -moz-transform: rotate(327.6deg);
  -ms-transform: rotate(327.6deg);
  -o-transform: rotate(327.6deg);
  transform: rotate(327.6deg);
}
.c100.p92 .bar {
  -webkit-transform: rotate(331.2deg);
  -moz-transform: rotate(331.2deg);
  -ms-transform: rotate(331.2deg);
  -o-transform: rotate(331.2deg);
  transform: rotate(331.2deg);
}
.c100.p93 .bar {
  -webkit-transform: rotate(334.8deg);
  -moz-transform: rotate(334.8deg);
  -ms-transform: rotate(334.8deg);
  -o-transform: rotate(334.8deg);
  transform: rotate(334.8deg);
}
.c100.p94 .bar {
  -webkit-transform: rotate(338.40000000000003deg);
  -moz-transform: rotate(338.40000000000003deg);
  -ms-transform: rotate(338.40000000000003deg);
  -o-transform: rotate(338.40000000000003deg);
  transform: rotate(338.40000000000003deg);
}
.c100.p95 .bar {
  -webkit-transform: rotate(342deg);
  -moz-transform: rotate(342deg);
  -ms-transform: rotate(342deg);
  -o-transform: rotate(342deg);
  transform: rotate(342deg);
}
.c100.p96 .bar {
  -webkit-transform: rotate(345.6deg);
  -moz-transform: rotate(345.6deg);
  -ms-transform: rotate(345.6deg);
  -o-transform: rotate(345.6deg);
  transform: rotate(345.6deg);
}
.c100.p97 .bar {
  -webkit-transform: rotate(349.2deg);
  -moz-transform: rotate(349.2deg);
  -ms-transform: rotate(349.2deg);
  -o-transform: rotate(349.2deg);
  transform: rotate(349.2deg);
}
.c100.p98 .bar {
  -webkit-transform: rotate(352.8deg);
  -moz-transform: rotate(352.8deg);
  -ms-transform: rotate(352.8deg);
  -o-transform: rotate(352.8deg);
  transform: rotate(352.8deg);
}
.c100.p99 .bar {
  -webkit-transform: rotate(356.40000000000003deg);
  -moz-transform: rotate(356.40000000000003deg);
  -ms-transform: rotate(356.40000000000003deg);
  -o-transform: rotate(356.40000000000003deg);
  transform: rotate(356.40000000000003deg);
}
.c100.p100 .bar {
  -webkit-transform: rotate(360deg);
  -moz-transform: rotate(360deg);
  -ms-transform: rotate(360deg);
  -o-transform: rotate(360deg);
  transform: rotate(360deg);
}
.c100:hover {
  cursor: default;
}
.c100:hover > span {
  width: 3.33em;
  line-height: 3.33em;
  font-size: 0.3em;
  color: #307bbb;
}
.c100:hover:after {
  top: 0.04em;
  left: 0.04em;
  width: 0.92em;
  height: 0.92em;
}
.c100.dark {
  background-color: #777777;
}
.c100.dark .bar,
.c100.dark .fill {
  border-color: #c6ff00 !important;
}
.c100.dark > span {
  color: #777777;
}
.c100.dark:after {
  background-color: #666666;
}
.c100.dark:hover > span {
  color: #c6ff00;
}
.c100.green .bar,
.c100.green .fill {
  border-color: #4db53c !important;
}
.c100.green:hover > span {
  color: #4db53c;
}
.c100.green.dark .bar,
.c100.green.dark .fill {
  border-color: #5fd400 !important;
}
.c100.green.dark:hover > span {
  color: #5fd400;
}
.c100.orange .bar,
.c100.orange .fill {
  border-color: #dd9d22 !important;
}
.c100.orange:hover > span {
  color: #dd9d22;
}
.c100.orange.dark .bar,
.c100.orange.dark .fill {
  border-color: #e08833 !important;
}
.c100.orange.dark:hover > span {
  color: #e08833;
}
/* @media (max-width: 992px) {
  .page-salesforecast .page-header {
      height: 505px !important;
  }
  .page-salesforecast .page-content-card {
      padding-top: 500px !important;
  }
  .page-footer-sales {
      margin-top: 330px;
  }
  .footer-box {
    padding-top: 46px;
    padding-bottom: 26px;
  }
  .quarterValue {
    margin-bottom: 15px;
  }
} */
@media (max-width: 992px) {
  .quarterValue {
    margin-bottom: 15px;
  }
}
/* @media (max-width: 768px) {
  .page-salesforecast .page-header {
    height: 660px !important;
  }
  .page-salesforecast .page-middle {
    margin-top: -90px;
    height: 890px !important;
  }
  .card-mb {
    margin-bottom: 15px;
  }
}
.page-salesforecast .page-header {
  height: 505px;
}
.page-salesforecast .page-middle {
  margin-top: -90px;
  height: 550px;
}
.footer-box {
  padding-top: 100px;
  padding-bottom: 26px;
}
.page-salesforecast .page-middle {
  margin-top: -90px;
  height: 540px;
}

.page-salesforecast .page-content-card {
  padding-top: 480px;
} */
</style>
<script>
import { HalfCircleSpinner } from "epic-spinners";
import Salesforecast from "./mixins/salesforecast";

export default {
  data() {
    return {
      fiscalYear: "",
      productsFiscalYear: "",
      leadsFiscalYear: "",
      customersFiscalYear: "",
      years_to_set: [],
      hide_el_dropdown: false,
      series: [0],
      seriesTotal: [0],
      chartOptions: {
        chart: {
          height: 250,
          type: "radialBar",
        },
        plotOptions: {
          radialBar: {
            inverseOrder: false,
            hollow: {
              size: "70%",
            },
            dataLabels: {
              showOn: "always",
              name: {
                show: true,
                color: "#ffffff",
                fontSize: "18px",
                fontWeight: "bold",
                offsetY: 30,
              },
              value: {
                color: "#ffffff",
                fontWeight: "bold",
                fontSize: "35px",
                show: true,
                offsetY: -20,
              },
            },
            track: {
              show: true,
              background: "#fff",
              strokeWidth: "97%",
              opacity: 1,
              margin: 5,
              dropShadow: {
                enabled: false,
                top: 0,
                left: 0,
                blur: 3,
                opacity: 0.5,
              },
            },
          },
        },
        fill: {
          colors: ["#ffc72f", "#ffc72f"],
        },
        stroke: {
          lineCap: "round",
        },
        labels: ["Sales"],
      },
      salesData: [],
      quarter: {
        forecast: {
          one: 0,
          two: 0,
          three: 0,
          four: 0,
        },
        current: {
          one: 0,
          two: 0,
          three: 0,
          four: 0,
        },
      },
      currentSales: {
        jan: 0,
        feb: 0,
        mar: 0,
        apr: 0,
        may: 0,
        jun: 0,
        jul: 0,
        aug: 0,
        sept: 0,
        oct: 0,
        nov: 0,
        dec: 0,
      },
      totalForecast: 0,
      totalForecastQty: 0,
      totalCurrentSales: 0,
      totalCurrentSalesQty: 0,
      leads: [],
      leadstable: [],
      totalLeads: 0,
      individualLeads: [],
      products: {
        new: 0,
        total: 0,
        categories: 0,
      },
      leadFunnelData: [],
      noSalesData: true,
      noLeads: true,
      noLeadsFunnel: true,
      noMap: true,
      noSalesByCategory: true,
      salesByCategories: [],
      cust: [],
      topFiveCustomers: [],
      noTopFiveCustomers: true,
      allProducts: [],
      noProducts: true,
      ele_id: null,
      ajaxCallinprogress: false,
      apiCall: "",
      salesCompInterval: "monthly",
      salesCategoryInterval: "monthly",
      salesCompParameter: {
        name: "Value",
        value: "value"
      },
      salesCompParameterOptions: [
        {
          name: "Value",
          value: "value"
        },
        {
          name: "Quantity",
          value: "quantity"
        }
      ],
      salesCompComparison: {
        name: "Sales Comparison Chart",
        value: "sales_compare"
      },
      salesCompComparisonOptions: [
        {
          name: "Sales Comparison Chart",
          value: "sales_compare"
        },
        {
          name: "Gross Margin Chart",
          value: "gross_margin"
        }
      ],
      productType: {
        name: "All Products",
        value: "all"
      },
      productTypeOptions: [
        {
          name: "All Products",
          value: "all"
        },
        {
          name: "Top 5 Products",
          value: "worst"
        },
        {
          name: "Worst 5 Products",
          value: "worst"
        }
      ],
      prodCategories: [],
      prodComparison: "gross_margin",
      prodFiscalYears: [],
      prodFiscalYear: "",
      totalCustomers: 0,
      newCustomers: 0,
      leadsFunnelToView: "Q 1 (Jan - Mar)",
    };
  },
  components: {
    HalfCircleSpinner,
  },
  mixins: [Salesforecast],
  watch: {
    salesCompComparison: function(val) {
      if (val.value === "gross_margin") {
        this.salesCompParameter = {
          name: "Value",
          value: "value"
        };
        this.salesCompParameterOptions = [
          {
            name: "Value",
            value: "value"
          },
          {
            name: "Percentage",
            value: "percentage"
          }
        ];
      } else if (val.value === "sales_compare") {
        this.salesCompParameter = {
          name: "Value",
          value: "value"
        };
        this.salesCompParameterOptions = [
          {
            name: "Value",
            value: "value"
          },
          {
            name: "Quantity",
            value: "quantity"
          }
        ];
      }
    },
    leadsFunnelToView: function() {
      setTimeout(() => {
        this.leadFunnel();
      }, 1000);
    }
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    createSaleForecast(type) {
      this.$router.push({ name: "CreateSalesForecast" });
      if (type == "actual") {
        localStorage.setItem("salesForecastType", "actual");
      }
    },
    progress(event, progress, stepValue) {
      // console.log(stepValue);
    },
    progress_end(event) {
      // console.log("Circle progress end");
    },
    pushToProdCategories(item) {
      if (this.prodCategories.includes(item)) {
        this.prodCategories = this.prodCategories.filter(x => x !== item);
      } else {
        this.prodCategories.push(item);
      }
    },
    salesCompChart() {
      let quarterlyData = {
        q1: {
          forecast: 0,
          sales: 0,
          pending: 0,
        },
        q2: {
          forecast: 0,
          sales: 0,
          pending: 0,
        },
        q3: {
          forecast: 0,
          sales: 0,
          pending: 0,
        },
        q4: {
          forecast: 0,
          sales: 0,
          pending: 0,
        }
      };
      let monthlyData = {
        jan: {
          forecast: 0,
          sales: 0,
          pending: 0,
        },
        feb: {
          forecast: 0,
          sales: 0,
          pending: 0,
        },
        mar: {
          forecast: 0,
          sales: 0,
          pending: 0,
        },
        apr: {
          forecast: 0,
          sales: 0,
          pending: 0,
        },
        may: {
          forecast: 0,
          sales: 0,
          pending: 0,
        },
        jun: {
          forecast: 0,
          sales: 0,
          pending: 0,
        },
        jul: {
          forecast: 0,
          sales: 0,
          pending: 0,
        },
        aug: {
          forecast: 0,
          sales: 0,
          pending: 0,
        },
        sept: {
          forecast: 0,
          sales: 0,
          pending: 0,
        },
        oct: {
          forecast: 0,
          sales: 0,
          pending: 0,
        },
        nov: {
          forecast: 0,
          sales: 0,
          pending: 0,
        },
        dec: {
          forecast: 0,
          sales: 0,
          pending: 0,
        },
      };
      let yearlyData = [];
      if (this.salesCompInterval === "quarterly") {
        this.salesData.forEach(x => {
          if (x.quarter == "q1") {
            quarterlyData.q1.forecast = x.value.forecast;
            quarterlyData.q1.sales = x.value.sales;
            quarterlyData.q1.pending = x.value.pending;
          }
          if (x.quarter == "q2") {
            quarterlyData.q2.forecast = x.value.forecast;
            quarterlyData.q2.sales = x.value.sales;
            quarterlyData.q2.pending = x.value.pending;
          }
          if (x.quarter == "q3") {
            quarterlyData.q3.forecast = x.value.forecast;
            quarterlyData.q3.sales = x.value.sales;
            quarterlyData.q3.pending = x.value.pending;
          }
          if (x.quarter == "q4") {
            quarterlyData.q4.forecast = x.value.forecast;
            quarterlyData.q4.sales = x.value.sales;
            quarterlyData.q4.pending = x.value.pending;
          }
        });
      }
      if (this.salesCompInterval === "monthly") {
        this.salesData.forEach(x => {
          if (x.month == "jan") {
            monthlyData.jan.forecast = x.value.forecast;
            monthlyData.jan.sales = x.value.sales;
            monthlyData.jan.pending = x.value.pending;
          }
          if (x.month == "feb") {
            monthlyData.feb.forecast = x.value.forecast;
            monthlyData.feb.sales = x.value.sales;
            monthlyData.feb.pending = x.value.pending;
          }
          if (x.month == "mar") {
            monthlyData.mar.forecast = x.value.forecast;
            monthlyData.mar.sales = x.value.sales;
            monthlyData.mar.pending = x.value.pending;
          }
          if (x.month == "apr") {
            monthlyData.apr.forecast = x.value.forecast;
            monthlyData.apr.sales = x.value.sales;
            monthlyData.apr.pending = x.value.pending;
          }
          if (x.month == "may") {
            monthlyData.may.forecast = x.value.forecast;
            monthlyData.may.sales = x.value.sales;
            monthlyData.may.pending = x.value.pending;
          }
          if (x.month == "jun") {
            monthlyData.jun.forecast = x.value.forecast;
            monthlyData.jun.sales = x.value.sales;
            monthlyData.jun.pending = x.value.pending;
          }
          if (x.month == "jul") {
            monthlyData.jul.forecast = x.value.forecast;
            monthlyData.jul.sales = x.value.sales;
            monthlyData.jul.pending = x.value.pending;
          }
          if (x.month == "aug") {
            monthlyData.aug.forecast = x.value.forecast;
            monthlyData.aug.sales = x.value.sales;
            monthlyData.aug.pending = x.value.pending;
          }
          if (x.month == "sept") {
            monthlyData.sept.forecast = x.value.forecast;
            monthlyData.sept.sales = x.value.sales;
            monthlyData.sept.pending = x.value.pending;
          }
          if (x.month == "oct") {
            monthlyData.oct.forecast = x.value.forecast;
            monthlyData.oct.sales = x.value.sales;
            monthlyData.oct.pending = x.value.pending;
          }
          if (x.month == "nov") {
            monthlyData.nov.forecast = x.value.forecast;
            monthlyData.nov.sales = x.value.sales;
            monthlyData.nov.pending = x.value.pending;
          }
          if (x.month == "dec") {
            monthlyData.dec.forecast = x.value.forecast;
            monthlyData.dec.sales = x.value.sales;
            monthlyData.dec.pending = x.value.pending;
          }
        });
      }
      if (this.salesCompInterval === "yearly") {
        this.salesData.forEach(x => {
          yearlyData.push({
            category: x.year,
            first: x.value.forecast,
            second: x.value.sales,
            third: x.value.pending,
          });
        });
      }
      let vuethis = this;

      am4core.ready(function() {
        // Themes begin
        // am4core.useTheme(am4themes_dark);
        am4core.useTheme(am4themes_animated);
        // Themes end

        var chart = am4core.create("chartdiv", am4charts.XYChart);
        chart.colors.step = 2;

        chart.cursor = new am4charts.XYCursor();

        chart.legend = new am4charts.Legend();
        chart.legend.position = "top";
        chart.legend.align = "right";
        chart.legend.contentAlign = "right";
        chart.legend.display = "false";
        chart.legend.paddingBottom = 20;
        chart.legend.labels.template.maxWidth = 95;
        chart.legend.useDefaultMarker = true;
        let marker = chart.legend.markers.template.children.getIndex(0);
        marker.cornerRadius(12, 12, 12, 12);
        marker.width = 20;
        marker.height = 20;
        marker.strokeWidth = 1;
        marker.strokeOpacity = 1;
        marker.stroke = am4core.color("#ccc");

        chart.data = [];

        if (vuethis.salesCompInterval === "quarterly") {
          chart.data = [
            {
              category: "Quarter 1",
              first: quarterlyData.q1.forecast,
              second: quarterlyData.q1.sales,
              third: quarterlyData.q1.pending,
            },
            {
              category: "Quarter 2",
              first: quarterlyData.q2.forecast,
              second: quarterlyData.q2.sales,
              third: quarterlyData.q2.pending,
            },
            {
              category: "Quarter 3",
              first: quarterlyData.q3.forecast,
              second: quarterlyData.q3.sales,
              third: quarterlyData.q3.pending,
            },
            {
              category: "Quarter 4",
              first: quarterlyData.q4.forecast,
              second: quarterlyData.q4.sales,
              third: quarterlyData.q4.pending,
            },
          ];
        }
        if (vuethis.salesCompInterval === "monthly") {
          chart.data = [
            {
              category: "JAN",
              first: monthlyData.jan.forecast,
              second: monthlyData.jan.sales,
              third: monthlyData.jan.pending,
            },
            {
              category: "FEB",
              first: monthlyData.feb.forecast,
              second: monthlyData.feb.sales,
              third: monthlyData.feb.pending,
            },
            {
              category: "MAR",
              first: monthlyData.mar.forecast,
              second: monthlyData.mar.sales,
              third: monthlyData.mar.pending,
            },
            {
              category: "APR",
              first: monthlyData.apr.forecast,
              second: monthlyData.apr.sales,
              third: monthlyData.apr.pending,
            },
            {
              category: "MAY",
              first: monthlyData.may.forecast,
              second: monthlyData.may.sales,
              third: monthlyData.may.pending,
            },
            {
              category: "JUN",
              first: monthlyData.jun.forecast,
              second: monthlyData.jun.sales,
              third: monthlyData.jun.pending,
            },
            {
              category: "JUL",
              first: monthlyData.jul.forecast,
              second: monthlyData.jul.sales,
              third: monthlyData.jul.pending,
            },
            {
              category: "AUG",
              first: monthlyData.aug.forecast,
              second: monthlyData.aug.sales,
              third: monthlyData.aug.pending,
            },
            {
              category: "SEPT",
              first: monthlyData.sept.forecast,
              second: monthlyData.sept.sales,
              third: monthlyData.sept.pending,
            },
            {
              category: "OCT",
              first: monthlyData.oct.forecast,
              second: monthlyData.oct.sales,
              third: monthlyData.oct.pending,
            },
            {
              category: "NOV",
              first: monthlyData.nov.forecast,
              second: monthlyData.nov.sales,
              third: monthlyData.nov.pending,
            },
            {
              category: "DEC",
              first: monthlyData.dec.forecast,
              second: monthlyData.dec.sales,
              third: monthlyData.dec.pending,
            },
          ];
        }

        if (vuethis.salesCompInterval === "yearly") {
          chart.data = yearlyData;
        }

        var xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        xAxis.dataFields.category = "category";
        xAxis.tooltip.disabled = false;
        xAxis.renderer.cellStartLocation = 0.2;
        xAxis.renderer.cellEndLocation = 0.8;
        xAxis.renderer.grid.template.location = 0;
        xAxis.renderer.minGridDistance = 60;

        var yAxis = chart.yAxes.push(new am4charts.ValueAxis());
        yAxis.min = 0;

        function createSeries(value, name) {
          var series = chart.series.push(new am4charts.ColumnSeries());
          series.dataFields.valueY = value;
          series.dataFields.categoryX = "category";
          series.name = name;
          series.tooltipText = "{valueY}";

          series.events.on("hidden", arrangeColumns);
          series.events.on("shown", arrangeColumns);

          var bullet = series.bullets.push(new am4charts.LabelBullet());
          bullet.interactionsEnabled = false;
          bullet.dy = 30;
          bullet.label.fill = am4core.color("#ffffff");
          return series;
        }

        chart.colors.list = [
          am4core.color("#005dae"),
          am4core.color("#fdc72f"),
          am4core.color("#fdc72f"),
          am4core.color("#2acc98"),
        ];

        createSeries("first", "Sales Forecast");
        createSeries("second", "Actual Sales");
        createSeries("third", "Pending Sales");

        function arrangeColumns() {
          var series = chart.series.getIndex(0);

          var w = 1 - xAxis.renderer.cellStartLocation - (1 - xAxis.renderer.cellEndLocation);
          if (series.dataItems.length > 1) {
            var x0 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
            var x1 = xAxis.getX(series.dataItems.getIndex(1), "categoryX");
            var delta = ((x1 - x0) / chart.series.length) * w;
            if (am4core.isNumber(delta)) {
              var middle = chart.series.length / 2;

              var newIndex = 0;
              chart.series.each(function(series) {
                if (!series.isHidden && !series.isHiding) {
                  series.dummyData = newIndex;
                  newIndex++;
                } else {
                  series.dummyData = chart.series.indexOf(series);
                }
              });
              var visibleCount = newIndex;
              var newMiddle = visibleCount / 2;

              chart.series.each(function(series) {
                var trueIndex = chart.series.indexOf(series);
                var newIndex = series.dummyData;

                var dx = (newIndex - trueIndex + middle - newMiddle) * delta;

                series.animate(
                  { property: "dx", to: dx },
                  series.interpolationDuration,
                  series.interpolationEasing
                );
                series.bulletsContainer.animate(
                  { property: "dx", to: dx },
                  series.interpolationDuration,
                  series.interpolationEasing
                );
              });
            }
          }
        }
      }); // end am4core.ready()
    },
    secondChart() {
      let leadsChart = this.leadstable;
      let vuethis = this;
      am4core.ready(function() {
        // Themes begin
        // am4core.useTheme(am4themes_dark);
        am4core.useTheme(am4themes_animated);
        // Themes end

        // Create chart instance
        var chart = am4core.create("leads_chart", am4charts.PieChart);

        // Add data
        chart.data = leadsChart;

        // Add and configure Series
        var pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "value";
        pieSeries.dataFields.category = "name";
        pieSeries.slices.template.stroke = am4core.color("#ffffff");
        pieSeries.slices.template.strokeWidth = 2;
        pieSeries.slices.template.strokeOpacity = 1;
        pieSeries.labels.template.paddingTop = 0;
        pieSeries.labels.template.paddingBottom = 0;
        pieSeries.labels.template.fontSize = 10;

        // This creates initial animation
        pieSeries.hiddenState.properties.opacity = 1;
        pieSeries.hiddenState.properties.endAngle = -90;
        pieSeries.hiddenState.properties.startAngle = -90;
      }); // end am4core.ready()
    },
    leadFunnel() {
      let leadsFunnelChart = [];
      if (this.leadsFunnelToView == "Q 1 (Jan - Mar)") {
        for (let i=0; i<=2; i++) {
          leadsFunnelChart.push({
            category: this.leadFunnelData[i].month,
          });
        }
      } else if (this.leadsFunnelToView == "Q 2 (Apr - Jun)") {
        for (let i=3; i<=5; i++) {
          leadsFunnelChart.push({
            category: this.leadFunnelData[i].month,
          });
        }
      } else if (this.leadsFunnelToView == "Q 3 (Jul - Sep)") {
        for (let i=6; i<=8; i++) {
          leadsFunnelChart.push({
            category: this.leadFunnelData[i].month,
          });
        }
      } else if (this.leadsFunnelToView == "Q 4 (Oct - Dec)") {
        for (let i=9; i<=11; i++) {
          leadsFunnelChart.push({
            category: this.leadFunnelData[i].month,
          });
        }
      }
      leadsFunnelChart.forEach(x => {
        this.leadFunnelData.forEach(s => {
          if (s.month === x.category) {
            x.category = x.category.toUpperCase();
            for (let [key,value] of Object.entries(s.value)) {
              Object.assign(x, {
                [key]:value
              });
            }
          }
        });
      });
      let vuethis = this;
      am4core.ready(function() {
        // Themes begin
        // am4core.useTheme(am4themes_dark);
        am4core.useTheme(am4themes_animated);
        // Themes end

        var chart = am4core.create("leads_funnel", am4charts.XYChart);
        // chart.colors.list = [am4core.color("#005dae")];
        chart.cursor = new am4charts.XYCursor();

        chart.responsive.enabled = true;

        var xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        xAxis.dataFields.category = "category";
        xAxis.renderer.grid.template.location = 0;
        xAxis.renderer.cellStartLocation = 0.2;
        xAxis.renderer.cellEndLocation = 0.8;
        xAxis.renderer.minGridDistance = 60;

        var yAxis = chart.yAxes.push(new am4charts.ValueAxis());
        yAxis.min = 0;

        chart.colors.step = 2;
        function createSeries(value, name) {
          var series = chart.series.push(new am4charts.ColumnSeries());
          series.dataFields.valueY = value;
          series.dataFields.categoryX = "category";
          series.name = name;
          series.columns.template.tooltipText =
            "{category}:\n[bold]{valueY}[/]";
          series.tooltipText = "{valueY}";

          series.events.on("hidden", arrangeColumns);
          series.events.on("shown", arrangeColumns);

          var columnTemplate = series.columns.template;
          columnTemplate.strokeWidth = 2;
          columnTemplate.strokeOpacity = 1;

          var bullet = series.bullets.push(new am4charts.LabelBullet());
          bullet.interactionsEnabled = true;
          bullet.dy = 30;
          bullet.label.fill = am4core.color("#ffffff");
          return series;
        }

        chart.data = leadsFunnelChart;

        chart.colors.list = [
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
          am4core.color("#005dae"),
        ];

        for (let [key,value] of Object.entries(vuethis.leadFunnelData[0].value)) {
          createSeries(key,key);
        }

        function arrangeColumns() {
          var series = chart.series.getIndex(0);
          var w =
            1 -
            xAxis.renderer.cellStartLocation -
            (1 - xAxis.renderer.cellEndLocation);
          if (series.dataItems.length > 1) {
            var x0 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
            var x1 = xAxis.getX(series.dataItems.getIndex(1), "categoryX");
            var delta = ((x1 - x0) / chart.series.length) * w;
            if (am4core.isNumber(delta)) {
              var middle = chart.series.length / 2;

              var newIndex = 0;
              chart.series.each(function(series) {
                if (!series.isHidden && !series.isHiding) {
                  series.dummyData = newIndex;
                  newIndex++;
                } else {
                  series.dummyData = chart.series.indexOf(series);
                }
              });
              var visibleCount = newIndex;
              var newMiddle = visibleCount / 2;

              chart.series.each(function(series) {
                var trueIndex = chart.series.indexOf(series);
                var newIndex = series.dummyData;

                var dx = (newIndex - trueIndex + middle - newMiddle) * delta;

                series.animate(
                  { property: "dx", to: dx },
                  series.interpolationDuration,
                  series.interpolationEasing
                );
                series.bulletsContainer.animate(
                  { property: "dx", to: dx },
                  series.interpolationDuration,
                  series.interpolationEasing
                );
              });
            }
          }
        }
      }); // end am4core.ready()
    },
    topFiveCustomersChart() {
      let vuethis = this;

      am4core.ready(function() {
        // Themes begin
        // am4core.useTheme(am4themes_dark);
        am4core.useTheme(am4themes_animated);
        // Themes end

        var chart = am4core.create("top_five_customer", am4charts.XYChart);
        chart.colors.step = 2;

        chart.cursor = new am4charts.XYCursor();

        // chart.data = vuethis.topFiveCustomers;
        chart.data = vuethis.topFiveCustomers;

        chart.colors.step = 2;
        chart.colors.list = [
          am4core.color("#29c2e0"),
          am4core.color("#fdc72f"),
          am4core.color("#fdc72f"),
        ];

        var xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        xAxis.dataFields.category = "name";
        xAxis.tooltip.disabled = false;
        xAxis.renderer.cellStartLocation = 0.2;
        xAxis.renderer.cellEndLocation = 0.8;
        xAxis.renderer.grid.template.location = 0;
        xAxis.renderer.minGridDistance = 30;
        xAxis.renderer.grid.template.strokeWidth = 0;
        xAxis.renderer.labels.template.fill = am4core.color("#fff");

        var yAxis = chart.yAxes.push(new am4charts.ValueAxis());
        yAxis.min = 0;
        yAxis.renderer.grid.template.strokeWidth = 0;
        yAxis.renderer.labels.template.fill = am4core.color("#fff");

        function createSeries(value, name) {
          var series = chart.series.push(new am4charts.ColumnSeries());
          series.columns.template.column.width = am4core.percent(100);
          series.dataFields.valueY = value;
          series.dataFields.categoryX = "name";
          series.name = name;
          series.tooltipText = "{valueY}";

          series.events.on("hidden", arrangeColumns);
          series.events.on("shown", arrangeColumns);


          var bullet = series.bullets.push(new am4charts.LabelBullet());
          bullet.interactionsEnabled = false;
          bullet.dy = 30;
          bullet.label.fill = am4core.color("#ffffff");
          return series;
        }

        createSeries("current", "Sales");
        createSeries("forecast", "Forecast");

        function arrangeColumns() {
          var series = chart.series.getIndex(0);

          var w = 1 - xAxis.renderer.cellStartLocation - (1 - xAxis.renderer.cellEndLocation);
          if (series.dataItems.length > 1) {
            var x0 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
            var x1 = xAxis.getX(series.dataItems.getIndex(1), "categoryX");
            var delta = ((x1 - x0) / chart.series.length) * w;
            if (am4core.isNumber(delta)) {
              var middle = chart.series.length / 2;
              var newIndex = 0;
              chart.series.each(function(series) {
                if (!series.isHidden && !series.isHiding) {
                  series.dummyData = newIndex;
                  newIndex++;
                } else {
                  series.dummyData = chart.series.indexOf(series);
                }
              });
              var visibleCount = newIndex;
              var newMiddle = visibleCount / 2;
              chart.series.each(function(series) {
                var trueIndex = chart.series.indexOf(series);
                var newIndex = series.dummyData;
                var dx = (newIndex - trueIndex + middle - newMiddle) * delta;
                series.animate(
                  { property: "dx", to: dx },
                  series.interpolationDuration,
                  series.interpolationEasing
                );
                series.bulletsContainer.animate(
                  { property: "dx", to: dx },
                  series.interpolationDuration,
                  series.interpolationEasing
                );
              });
            }
          }
        }
      }); // end am4core.ready()
    },
    customerMap() {
      let vuethis = this;

      am4core.ready(function() {
        // Themes begin
        am4core.useTheme(am4themes_animated);
        var targetSVG =
          "M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z";

        // Create map instance
        var chart = am4core.create("map_sales_customers", am4maps.MapChart);

        // Set map definition
        chart.geodata = am4geodata_worldLow;
        chart.seriesContainer.draggable = true;
        chart.seriesContainer.resizable = false;
        chart.chartContainer.wheelable = false;

        // Set projection
        chart.projection = new am4maps.projections.Miller();

        // Create map polygon series
        var polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());

        // Exclude Antartica
        polygonSeries.exclude = ["AQ"];

        // Make map load polygon (like country names) data from GeoJSON
        polygonSeries.useGeodata = true;

        // Configure series
        var polygonTemplate = polygonSeries.mapPolygons.template;
        polygonTemplate.strokeOpacity = 0.5;
        polygonTemplate.nonScalingStroke = true;
        polygonTemplate.applyOnClones = true;
        polygonTemplate.togglable = true;
        polygonTemplate.tooltipText = "{name}";

        var lastSelected;
        polygonTemplate.events.on("hit", function(ev) {
          if (lastSelected) {
            lastSelected.isActive = false;
          }
          ev.target.series.chart.zoomToMapObject(ev.target);
          if (lastSelected !== ev.target) {
            lastSelected = ev.target;
          }
        });

        var ss = polygonTemplate.states.create("active");
        ss.properties.fill = chart.colors.getIndex(2);
        // Create hover state and set alternative fill color
        var hs = polygonTemplate.states.create("hover");
        hs.properties.fill = am4core.color("#005dae");

        // Zoom control
        chart.zoomControl = new am4maps.ZoomControl();

        var homeButton = new am4core.Button();
        homeButton.events.on("hit", function() {
          chart.goHome();
        });

        homeButton.icon = new am4core.Sprite();
        homeButton.padding(7, 5, 7, 5);
        homeButton.width = 30;
        homeButton.icon.path =
          "M16,8 L14,8 L14,16 L10,16 L10,10 L6,10 L6,16 L2,16 L2,8 L0,8 L8,0 L16,8 Z M16,8";
        homeButton.marginBottom = 10;
        homeButton.parent = chart.zoomControl;
        homeButton.insertBefore(chart.zoomControl.plusButton);

        // create capital markers
        var imageSeries = chart.series.push(new am4maps.MapImageSeries());

        // define template
        var imageSeriesTemplate = imageSeries.mapImages.template;
        var circle = imageSeriesTemplate.createChild(am4core.Sprite);
        circle.scale = 0.4;
        circle.fill = new am4core.InterfaceColorSet().getFor(
          "alternativeBackground"
        );
        circle.path = targetSVG;
        // what about scale...

        // set propertyfields
        imageSeriesTemplate.propertyFields.latitude = "latitude";
        imageSeriesTemplate.propertyFields.longitude = "longitude";

        imageSeriesTemplate.horizontalCenter = "middle";
        imageSeriesTemplate.verticalCenter = "middle";
        imageSeriesTemplate.align = "center";
        imageSeriesTemplate.valign = "middle";
        imageSeriesTemplate.width = 8;
        imageSeriesTemplate.height = 8;
        imageSeriesTemplate.nonScaling = true;
        imageSeriesTemplate.tooltipText = "{name}";
        imageSeriesTemplate.fill = am4core.color("#fff");
        imageSeriesTemplate.background.fillOpacity = 0;
        imageSeriesTemplate.background.fill = am4core.color("#005dae");
        imageSeriesTemplate.setStateOnChildren = true;
        imageSeriesTemplate.states.create("hover");

        imageSeries.data = vuethis.cust;
      }); // end am4core.ready()
    },
    salesCategories() {
      let salesbycategories = [];
      if (this.salesByCategories.length == 12) {
        this.salesByCategories.forEach(x => {
          salesbycategories.push({
            category: x.month,
          });
        });
        salesbycategories.forEach(x => {
          this.salesByCategories.forEach(s => {
            if (s.month === x.category) {
              x.category = x.category.toUpperCase();
              s.value.forEach(v => {
                Object.assign(x, {
                  [v.category]:v.sales
                });
              });
            }
          });
        });
      } else if (this.salesByCategories.length == 4) {
        this.salesByCategories.forEach(x => {
          salesbycategories.push({
            category: x.quarter,
          });
        });
        salesbycategories.forEach(x => {
          this.salesByCategories.forEach(s => {
            if (s.quarter === x.category) {
              s.value.forEach(v => {
                Object.assign(x, {
                  [v.category]:v.sales
                });
              });
            }
          });
        });
      }
      let vuethis = this;
      am4core.ready(function() {

        // Themes begin
        am4core.useTheme(am4themes_animated);
        // Themes end

        // Create chart instance
        var chart = am4core.create("sales_by_categories", am4charts.XYChart);

        chart.colors.step = 2;

        chart.cursor = new am4charts.XYCursor();

        chart.legend = new am4charts.Legend();
        chart.legend.position = "top";
        chart.legend.align = "right";
        chart.legend.contentAlign = "right";
        chart.legend.display = "false";
        chart.legend.paddingBottom = 20;
        chart.legend.labels.template.maxWidth = 95;
        chart.legend.useDefaultMarker = true;
        let marker = chart.legend.markers.template.children.getIndex(0);
        marker.cornerRadius(12, 12, 12, 12);
        marker.width = 20;
        marker.height = 20;
        marker.strokeWidth = 1;
        marker.strokeOpacity = 1;
        marker.stroke = am4core.color("#ccc");

        // Add data
        chart.data = salesbycategories;

        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "category";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.cellStartLocation = 0.2;
        categoryAxis.renderer.cellEndLocation = 0.8;
        categoryAxis.renderer.minGridDistance = 60;


        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;


        // Create series
        function createSeries(field, name) {

          // Set up series
          var series = chart.series.push(new am4charts.ColumnSeries());
          series.name = name;
          series.dataFields.valueY = field;
          series.dataFields.categoryX = "category";
          series.sequencedInterpolation = true;

          // Make it stacked
          series.stacked = true;

          // Configure columns
          series.columns.template.width = am4core.percent(60);
          series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";

          // Add label
          var labelBullet = series.bullets.push(new am4charts.LabelBullet());
          labelBullet.locationY = 0.5;
          labelBullet.label.hideOversized = true;

          return series;
        }

        chart.colors.list = [
          am4core.color("#ffb946"),
          am4core.color("#f7685b"),
          am4core.color("#2ed47a"),
          am4core.color("#885af8"),
          am4core.color("#109cf1"),
        ];

        vuethis.salesByCategories[0].value.forEach(x => {
          createSeries(x.category, x.category);
        });
      });
    },
    productsChart() {
      let vuethis = this;
      // let top5products = this.topFiveProducts
      am4core.ready(function() {
        // Themes begin
        // am4core.useTheme(am4themes_dark);
        am4core.useTheme(am4themes_animated);
        // Themes end

        var chart = am4core.create("products_chart", am4charts.XYChart);
        // Add percent sign to all numbers
        // chart.numberFormatter.numberFormat = "#.#'%'";

        // Add data
        chart.data = vuethis.allProducts;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "name";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;

        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "forecast";
        series.dataFields.categoryX = "name";
        series.clustered = false;
        series.tooltipText = "Forecast";

        var series2 = chart.series.push(new am4charts.ColumnSeries());
        series2.dataFields.valueY = "actual";
        series2.dataFields.categoryX = "name";
        series2.clustered = false;
        series2.columns.template.width = am4core.percent(50);
        series2.tooltipText = "Sales";

        chart.cursor = new am4charts.XYCursor();
        chart.cursor.lineX.disabled = true;
        chart.cursor.lineY.disabled = true;
      }); // end am4core.ready()
    },
    async getSalesForecastPercentage() {
      let res = await this.$http.post("/sales_forecast/dashboard/sales_forecast_data");
      if (res.data.status_id == 1) {
        this.totalCurrentSales = res.data.response.sales_forecast_data.current_sales.total_value || 0;
        this.totalCurrentSalesQty = res.data.response.sales_forecast_data.current_sales.total_quantity || 0;
        this.totalForecast = res.data.response.sales_forecast_data.forecast.total_value || 0;
        this.totalForecastQty = res.data.response.sales_forecast_data.forecast.total_quantity || 0;
        this.seriesTotal = [res.data.response.sales_forecast_data.percentage.value];
        if (this.totalCurrentSales > 0) {
          if (Number.isInteger(this.seriesTotal)) {
            this.series = [100 - this.seriesTotal[0]];
          } else {
            this.series = [(100 - this.seriesTotal[0]).toFixed(2)];
          }
        }
      }
    },
    async getQuarterlyTargets() {
      let res = await this.$http.post("/sales_forecast/dashboard/sales_target_quarterly", {
        fiscal_year: this.fiscalYear
      });
      if (res.data.status_id == 1) {
        this.quarter.forecast.one = res.data.response.quarterly_target_data.q1 || 0;
        this.quarter.forecast.two = res.data.response.quarterly_target_data.q2 || 0;
        this.quarter.forecast.three = res.data.response.quarterly_target_data.q3 || 0;
        this.quarter.forecast.four = res.data.response.quarterly_target_data.q4 || 0;
      }
    },
    getSalesCompChartSelected() {
      if (this.salesCompInterval === 'quarterly' || this.salesCompInterval === 'yearly') {
        this.salesCompInterval = 'monthly';
        this.getSalesCompChart();
      }
    },
    async getSalesCompChart() {
      let res = await this.$http.post("/sales_forecast/dashboard/sales_gross_graph", {
        fiscal_year: this.fiscalYear,
        interval: this.salesCompInterval,
        parameter: this.salesCompParameter.value,
        comparision: this.salesCompComparison.value,
      });
      if (res.data.status_id == 1 && res.data.response.data.length) {
        this.noSalesData = false;
        this.salesData = res.data.response.data;
        setTimeout(() => {
          this.salesCompChart();
        }, 1000);
      }
    },
    async getNumberOfProducts() {
      let res = await this.$http.post("/sales_forecast/dashboard/new_total_products_categories", {
        fiscal_year: this.productsFiscalYear
      });
      if (res.data.status_id == 1) {
        this.products.total = res.data.response.total_products;
        this.products.new = res.data.response.new_products;
        this.products.categories = res.data.response.total_categories;
      }
    },
    async getSalesByCategory() {
      let res = await this.$http.post("/sales_forecast/dashboard/sales_by_categories", {
        fiscal_year: this.productsFiscalYear,
        interval: this.salesCategoryInterval,
        sales_type: "actual_sales"
      });
      if (res.data.status_id == 1 && res.data.response.sales_by_category.length) {
        this.noSalesByCategory = false;
        this.salesByCategories = res.data.response.sales_by_category;
        setTimeout(() => {
          this.salesCategories();
        }, 1000);
      }
    },
    async getLeadsTable() {
      let res = await this.$http.post("/sales_forecast/dashboard/leads_table", {
        fiscal_year: this.leadsFiscalYear
      });
      if (res.data.status_id == 1) {
        this.noLeads = false;
        this.leadstable = [];
        for(let [key,value] of Object.entries(res.data.response.leads)) {
          this.leadstable.push({
            name: key,
            value: value
          });
        }
        this.totalLeads = res.data.response.total_leads;
        setTimeout(() => {
          this.secondChart();
        }, 1000);
      }
    },
    async getLeadsFunnel() {
      let res = await this.$http.post("/sales_forecast/dashboard/lead_funnel", {
        fiscal_year: this.leadsFiscalYear
      });
      if (res.data.status_id == 1 && res.data.response.leads_funnel_data.length) {
        this.noLeadsFunnel = false;
        this.leadFunnelData = res.data.response.leads_funnel_data;
        setTimeout(() => {
          this.leadFunnel();
        }, 1000);
      }
    },
    async getTotalNewCust() {
      let res = await this.$http.post("/sales_forecast/dashboard/new_total_customers", {
        fiscal_year: this.customersFiscalYear
      });
      if (res.data.status_id == 1) {
        this.totalCustomers = res.data.response.new_and_total_customers_data.total;
        this.newCustomers = res.data.response.new_and_total_customers_data.new;
      }
    },
    async getTopFiveCust() {
      let res = await this.$http.post("/sales_forecast/dashboard/top_five_customers", {
        fiscal_year: this.customersFiscalYear
      });
      if (res.data.status_id == 1 && res.data.response.top_five_customers_data.length) {
        this.noTopFiveCustomers = false;
        this.topFiveCustomers = res.data.response.top_five_customers_data;
        setTimeout(() => {
          this.topFiveCustomersChart();
        }, 1000);
      }
    },
    async getCustomerLocation() {
      let res = await this.$http.post("sales_forecast/dashboard/customer_locations", {
        fiscal_year: this.customersFiscalYear
      });
      if (res.data.status_id == 1 && res.data.response.customers_locations_data.length) {
        this.noMap = false;
        this.cust = res.data.response.customers_locations_data;
      } else {
        this.cust = [];
        this.noMap = true;
      }
      setTimeout(() => {
        this.customerMap();
      }, 1000);
    },
    async getFiscalYears() {
      let res = await this.$http.post("/sales_forecast/dashboard/target_years");
      if (res.data.status_id == 1) {
        this.prodFiscalYears = res.data.response.target_years;
        this.prodFiscalYear = this.prodFiscalYears[0];
      }
    },
    async getAllTopWorstProds() {
      this.hide_el_dropdown = true;
      let res = await this.$http.post("/sales_forecast/dashboard/top_worst_all_products", {
        fiscal_year: this.productsFiscalYear,
        product_type: this.productType.value,
        categories: this.prodCategories,
        comparison: this.prodComparison,
      });
      if (res.data.status_id == 1 && res.data.response.products.length) {
        this.noProducts = false;
        this.allProducts = res.data.response.products;
        setTimeout(() => {
          this.productsChart();
        }, 1000);
      }
    },
    getData() {
      this.totalForecast = 0;
      this.totalCurrentSales = 0;
      this.quarter = {
        forecast: {
          one: 0,
          two: 0,
          three: 0,
          four: 0,
        },
        current: {
          one: 0,
          two: 0,
          three: 0,
          four: 0,
        },
      };
      this.leads = [];
      this.leadstable = [];
      this.leadFunnelData = [];
      this.totalLeads = 0;
      this.cust = [];
      this.allProducts = [];

      this.ajaxCallinprogress = true;

      if (!this.apiCall) {
        this.apiCall = "sales,forecast,percentage";
        if (this.apiCall === "sales,forecast,percentage") {
          this.getSalesForecastPercentage();
        }
        this.apiCall = "quarterly targets";
        if (this.apiCall === "quarterly targets") {
          this.getQuarterlyTargets();
        }
        this.apiCall = "sales comp chart";
        if (this.apiCall === "sales comp chart") {
          this.getSalesCompChart();
        }
        this.apiCall = "total,new products,total categories";
        if (this.apiCall === "total,new products,total categories") {
          this.getNumberOfProducts();
        }
        this.apiCall = "sales by category";
        if (this.apiCall === "sales by category") {
          this.getSalesByCategory();
        }
        this.apiCall = "leads table";
        if (this.apiCall === "leads table") {
          this.getLeadsTable();
        }
        this.apiCall = "leads funnel";
        if (this.apiCall === "leads funnel") {
          this.getLeadsFunnel();
        }
        this.apiCall = "total and new customers";
        if (this.apiCall === "total and new customers") {
          this.getTotalNewCust();
        }
        this.apiCall = "top 5 customers";
        if (this.apiCall === "top 5 customers") {
          this.getTopFiveCust();
        }
        this.apiCall = "customer location";
        if (this.apiCall === "customer location") {
          this.getCustomerLocation();
        }
        this.apiCall = "fiscal years";
        if (this.apiCall === "fiscal years") {
          this.getFiscalYears();
        }
        this.apiCall = "all top and worst prod";
        if (this.apiCall === "all top and worst prod") {
          this.getAllTopWorstProds();
        }
      }

      this.ajaxCallinprogress = false;
    },
    yearNext() {
      let year = this.years_to_set[5];
      this.years_to_set = [];
      for (let i = 0; i < 6; i++) {
        this.years_to_set.push(year + i);
      }
    },
    yearPrev() {
      let year = this.years_to_set[0];
      this.years_to_set = [];
      for (let i = 0; i < 6; i++) {
        this.years_to_set.push(year - i);
      }
      this.years_to_set.reverse();
    },
    yearClicked(startyear, endyear, type) {
      if (type === "fiscal") {
        this.fiscalYear = startyear + "-" + endyear;
      }
      if (type === "products") {
        this.productsFiscalYear = startyear + "-" + endyear;
      }
      if (type === "leads") {
        this.leadsFiscalYear = startyear + "-" + endyear;
      }
      if (type === "customers") {
        this.customersFiscalYear = startyear + "-" + endyear;
      }
      if (type === "all_products") {
        this.prodFiscalYear = startyear + "-" + endyear;
      }
    },
    dropdownTriggered(event) {
      if (!event) {
        this.selectedFilter = "";
      }
      if (event) {
        this.hide_el_dropdown = false;
      }
    },
    getFilteredListData(type) {
      this.hide_el_dropdown = true;
      if (type === "fiscal") {
        this.getSalesForecastPercentage();
        this.getQuarterlyTargets();
        this.getSalesCompChart();
      }
      if (type === "products") {
        this.getNumberOfProducts();
        this.getSalesByCategory();
        this.getAllTopWorstProds();
      }
      if (type === "leads") {
        this.getLeadsTable();
        this.getLeadsFunnel();
      }
      if (type === "customers") {
        this.getTotalNewCust();
        this.getTopFiveCust();
        this.getCustomerLocation();
      }
    },
  },
  created() {
    for (let i = 0; i < 6; i++) {
      let year = new Date().getFullYear();
      this.years_to_set.push(year + i);
    };
    this.fiscalYear = this.years_to_set[0] + "-" + this.years_to_set[1];
    this.productsFiscalYear = this.years_to_set[0] + "-" + this.years_to_set[1];
    this.leadsFiscalYear = this.years_to_set[0] + "-" + this.years_to_set[1];
    this.customersFiscalYear = this.years_to_set[0] + "-" + this.years_to_set[1];
  },
  mounted() {
    this.getData();
  },
  computed: {
    selectedCompany() {
      return this.$store.getters.selectedCompany;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/SalesForecast.vue